export const lanGs = {
    'ИИН': {
        nameRu: "ИИН",
        nameKz: "ЖСН",
        nameEn: 'IIN',
    },
    'БИН': {
        nameRu: "БИН",
        nameKz: "БСН",
        nameEn: 'BIN',
    },
    'Ошибка загрузки уведомлений:': {
        nameRu: "Ошибка загрузки уведомлений:",
        nameKz: "Хабарландыруларды жүктеу қатесі:",
        nameEn: 'Error loading notifications:',
    },
    'ID полета не указан': {
        nameRu: "ID полета не указан",
        nameKz: "Ұшу ID көрсетілмеген",
        nameEn: 'Flight ID is not specified',
    },
    'Заявка на полет не найдена': {
        nameRu: "Заявка на полет не найдена",
        nameKz: "Ұшу өтініші табылмады",
        nameEn: 'Flight application not found',
    },
    'У вас нет доступа к просмотру этого паспорта полета. Доступ имеют только владелец заявки, сотрудники полиции и администраторы.': {
        nameRu: "У вас нет доступа к просмотру этого паспорта полета. Доступ имеют только владелец заявки, сотрудники полиции и администраторы.",
        nameKz: "Сізде бұл ұшу паспортын қарауға қол жеткізу жоқ. Тек өтініш иесі, полиция қызметкерлері және әкімшілер қол жеткізе алады.",
        nameEn: 'You do not have access to view this flight passport. Access is available only to the application owner, police officers, and administrators.',
    },
    'Эта заявка еще не одобрена. Паспорт полета доступен только для одобренных заявок.': {
        nameRu: "Эта заявка еще не одобрена. Паспорт полета доступен только для одобренных заявок.",
        nameKz: "Бұл өтініш әлі мақұлданбаған. Ұшу паспорты тек мақұлданған өтініштер үшін қолжетімді.",
        nameEn: 'This application has not been approved yet. The flight passport is available only for approved applications.',
    },
    'Ошибка загрузки данных полета': {
        nameRu: "Ошибка загрузки данных полета",
        nameKz: "Ұшу деректерін жүктеу қатесі",
        nameEn: 'Error loading flight data',
    },
    'Мультироторный': {
        nameRu: "Мультироторный",
        nameKz: "Көпроторлы",
        nameEn: 'Multirotor',
    },
    'Самолетный': {
        nameRu: "Самолетный",
        nameKz: "Ұшақтық",
        nameEn: 'Fixed-wing',
    },
    'Гибридный': {
        nameRu: "Гибридный",
        nameKz: "Гибридті",
        nameEn: 'Hybrid',
    },
    'Не указан': {
        nameRu: "Не указан",
        nameKz: "Көрсетілмеген",
        nameEn: 'Not specified',
    },
    'Ошибка': {
        nameRu: "Ошибка",
        nameKz: "Қате",
        nameEn: 'Error',
    },
    'На главную': {
        nameRu: "На главную",
        nameKz: "Басты бетке",
        nameEn: 'Home',
    },
    'Назад': {
        nameRu: "Назад",
        nameKz: "Артқа",
        nameEn: 'Back',
    },
    'Скачать PDF': {
        nameRu: "Скачать PDF",
        nameKz: "PDF жүктеу",
        nameEn: 'Download PDF',
    },
    'Паспорт полета': {
        nameRu: "Паспорт полета",
        nameKz: "Ұшу паспорты",
        nameEn: 'Flight Passport',
    },
    'Разрешение на выполнение полета беспилотного летательного аппарата': {
        nameRu: "Разрешение на выполнение полета беспилотного летательного аппарата",
        nameKz: "Пилотсыз ұшу аппаратының ұшуын орындауға рұқсат",
        nameEn: 'Permit to operate an unmanned aircraft flight',
    },
    'Заявка одобрена': {
        nameRu: "Заявка одобрена",
        nameKz: "Өтініш мақұлданды",
        nameEn: 'Application approved',
    },
    'Данная заявка была одобрена модератором и разрешает выполнение полета': {
        nameRu: "Данная заявка была одобрена модератором и разрешает выполнение полета",
        nameKz: "Бұл өтініш модератормен мақұлданды және ұшу орындауға рұқсат береді",
        nameEn: 'This application was approved by a moderator and authorizes the flight',
    },
    'Дата одобрения:': {
        nameRu: "Дата одобрения:",
        nameKz: "Мақұлдау күні:",
        nameEn: 'Approval date:',
    },
    'Отсканируйте QR код для проверки подлинности разрешения': {
        nameRu: "Отсканируйте QR код для проверки подлинности разрешения",
        nameKz: "Рұқсаттың шынайылығын тексеру үшін QR кодты сканерлеңіз",
        nameEn: 'Scan the QR code to verify the permit authenticity',
    },
    'Информация о пользователе': {
        nameRu: "Информация о пользователе",
        nameKz: "Пайдаланушы туралы ақпарат",
        nameEn: 'User information',
    },
    'ФИО': {
        nameRu: "ФИО",
        nameKz: "Аты-жөні",
        nameEn: 'Full name',
    },
    'Не указано': {
        nameRu: "Не указано",
        nameKz: "Көрсетілмеген",
        nameEn: 'Not specified',
    },
    'Телефон': {
        nameRu: "Телефон",
        nameKz: "Телефон",
        nameEn: 'Phone',
    },
    'ИИН/БИН': {
        nameRu: "ИИН/БИН",
        nameKz: "ЖСН/БСН",
        nameEn: 'IIN/BIN',
    },
    'Информация о беспилотном летательном аппарате': {
        nameRu: "Информация о беспилотном летательном аппарате",
        nameKz: "Пилотсыз ұшу аппараты туралы ақпарат",
        nameEn: 'Unmanned aircraft information',
    },
    'Модель': {
        nameRu: "Модель",
        nameKz: "Модель",
        nameEn: 'Model',
    },
    'Бортовой номер': {
        nameRu: "Бортовой номер",
        nameKz: "Борт нөмірі",
        nameEn: 'Registration number',
    },
    'Серийный номер': {
        nameRu: "Серийный номер",
        nameKz: "Сериялық нөмір",
        nameEn: 'Serial number',
    },
    'Тип БАС': {
        nameRu: "Тип БАС",
        nameKz: "БАҚ түрі",
        nameEn: 'UAS type',
    },
    'Вес': {
        nameRu: "Вес",
        nameKz: "Салмақ",
        nameEn: 'Weight',
    },
    'кг': {
        nameRu: "кг",
        nameKz: "кг",
        nameEn: 'kg',
    },
    'Информация о полете': {
        nameRu: "Информация о полете",
        nameKz: "Ұшу туралы ақпарат",
        nameEn: 'Flight information',
    },
    'Дата полета': {
        nameRu: "Дата полета",
        nameKz: "Ұшу күні",
        nameEn: 'Flight date',
    },
    'Время начала': {
        nameRu: "Время начала",
        nameKz: "Басталу уақыты",
        nameEn: 'Start time',
    },
    'Время окончания': {
        nameRu: "Время окончания",
        nameKz: "Аяқталу уақыты",
        nameEn: 'End time',
    },
    'Максимальная высота': {
        nameRu: "Максимальная высота",
        nameKz: "Максималды биіктік",
        nameEn: 'Maximum altitude',
    },
    'м': {
        nameRu: "м",
        nameKz: "м",
        nameEn: 'm',
    },
    'Назначение полета': {
        nameRu: "Назначение полета",
        nameKz: "Ұшу мақсаты",
        nameEn: 'Flight purpose',
    },
    'Статус': {
        nameRu: "Статус",
        nameKz: "Мәртебе",
        nameEn: 'Status',
    },
    'Одобрено': {
        nameRu: "Одобрено",
        nameKz: "Мақұлданды",
        nameEn: 'Approved',
    },
    'Примечания': {
        nameRu: "Примечания",
        nameKz: "Ескертулер",
        nameEn: 'Notes',
    },
    'Маршрут полета': {
        nameRu: "Маршрут полета",
        nameKz: "Ұшу маршруты",
        nameEn: 'Flight route',
    },
    'Микросектор': {
        nameRu: "Микросектор",
        nameKz: "Микросектор",
        nameEn: 'Microsector',
    },
    'Маршрут не указан': {
        nameRu: "Маршрут не указан",
        nameKz: "Маршрут көрсетілмеген",
        nameEn: 'Route not specified',
    },
    'Данный документ является официальным разрешением на выполнение полета. При проверке сотрудниками правоохранительных органов предъявите данный документ или отсканируйте QR код.': {
        nameRu: "Данный документ является официальным разрешением на выполнение полета. При проверке сотрудниками правоохранительных органов предъявите данный документ или отсканируйте QR код.",
        nameKz: "Бұл құжат ұшу орындауға ресми рұқсат болып табылады. Құқық қорғау органдарының қызметкерлері тексерген кезде осы құжатты көрсетіңіз немесе QR кодты сканерлеңіз.",
        nameEn: 'This document is an official flight permit. During inspection by law enforcement officers, present this document or scan the QR code.',
    },
    'Документ сгенерирован:': {
        nameRu: "Документ сгенерирован:",
        nameKz: "Құжат жасалды:",
        nameEn: 'Document generated:',
    },
    'неизвестно': {
        nameRu: "неизвестно",
        nameKz: "белгісіз",
        nameEn: 'unknown',
    },
    'Не удалось загрузить уведомления': {
        nameRu: "Не удалось загрузить уведомления",
        nameKz: "Хабарландыруларды жүктеу мүмкін болмады",
        nameEn: 'Failed to load notifications',
    },
    'Не удалось архивировать уведомление': {
        nameRu: "Не удалось архивировать уведомление",
        nameKz: "Хабарландыруды мұрағалау мүмкін болмады",
        nameEn: 'Failed to archive notification',
    },
    'Уведомления': {
        nameRu: "Уведомления",
        nameKz: "Хабарландырулар",
        nameEn: 'Notifications',
    },
    'Активные': {
        nameRu: "Активные",
        nameKz: "Белсенді",
        nameEn: 'Active',
    },
    'Архив': {
        nameRu: "Архив",
        nameKz: "Мұраға",
        nameEn: 'Archive',
    },
    'Нет активных уведомлений': {
        nameRu: "Нет активных уведомлений",
        nameKz: "Белсенді хабарландырулар жоқ",
        nameEn: 'No active notifications',
    },
    'Нет архивных уведомлений': {
        nameRu: "Нет архивных уведомлений",
        nameKz: "Мұрағаланған хабарландырулар жоқ",
        nameEn: 'No archived notifications',
    },
    'Комментарий модератора:': {
        nameRu: "Комментарий модератора:",
        nameKz: "Модератордың түсініктемесі:",
        nameEn: 'Moderator comment:',
    },
    'Пользователь': {
        nameRu: "Пользователь",
        nameKz: "Пайдаланушы",
        nameEn: 'User',
    },
    'Главная': {
        nameRu: "Главная",
        nameKz: "Басты",
        nameEn: 'Home',
    },
    'Меню': {
        nameRu: "Меню",
        nameKz: "Мәзір",
        nameEn: 'Menu',
    },
    'Карта': {
        nameRu: "Карта",
        nameKz: "Карта",
        nameEn: 'Map',
    },
    'Погода': {
        nameRu: "Погода",
        nameKz: "Ауа райы",
        nameEn: 'Weather',
    },
    'Преимущества': {
        nameRu: "Преимущества",
        nameKz: "Артықшылықтар",
        nameEn: 'Benefits',
    },
    'Галерея': {
        nameRu: "Галерея",
        nameKz: "Галерея",
        nameEn: 'Gallery',
    },
    'Возможности': {
        nameRu: "Возможности",
        nameKz: "Мүмкіндіктер",
        nameEn: 'Use cases',
    },
    'Админ': {
        nameRu: "Админ",
        nameKz: "Әкімші",
        nameEn: 'Admin',
    },
    'Личный кабинет': {
        nameRu: "Личный кабинет",
        nameKz: "Жеке кабинет",
        nameEn: 'Profile',
    },
    'Русский': {
        nameRu: "Русский",
        nameKz: "Орысша",
        nameEn: 'Russian',
    },
    'Ру': {
        nameRu: "Ру",
        nameKz: "Ру",
        nameEn: 'Ru',
    },
    'Выход': {
        nameRu: "Выход",
        nameKz: "Шығу",
        nameEn: 'Log out',
    },
    'Вход': {
        nameRu: "Вход",
        nameKz: "Кіру",
        nameEn: 'Log in',
    },
    'Успешный вход в систему': {
        nameRu: "Успешный вход в систему",
        nameKz: "Жүйеге сәтті кірді",
        nameEn: 'Successfully signed in',
    },
    'Ошибка авторизации': {
        nameRu: "Ошибка авторизации",
        nameKz: "Авторизация қатесі",
        nameEn: 'Authorization error',
    },
    'Произошла ошибка при авторизации': {
        nameRu: "Произошла ошибка при авторизации",
        nameKz: "Авторизация кезінде қате орын алды",
        nameEn: 'An error occurred during authorization',
    },
    'Вход в систему': {
        nameRu: "Вход в систему",
        nameKz: "Жүйеге кіру",
        nameEn: 'Sign in',
    },
    'Войдите для управления полетами дронов': {
        nameRu: "Войдите для управления полетами дронов",
        nameKz: "Дрондардың ұшуын басқару үшін кіріңіз",
        nameEn: 'Sign in to manage drone flights',
    },
    'Электронная почта': {
        nameRu: "Электронная почта",
        nameKz: "Электрондық пошта",
        nameEn: 'Email',
    },
    'Введите email': {
        nameRu: "Введите email",
        nameKz: "Email енгізіңіз",
        nameEn: 'Enter email',
    },
    'Некорректный email': {
        nameRu: "Некорректный email",
        nameKz: "Дұрыс емес email",
        nameEn: 'Invalid email',
    },
    'Пароль': {
        nameRu: "Пароль",
        nameKz: "Құпия сөз",
        nameEn: 'Password',
    },
    'Введите пароль': {
        nameRu: "Введите пароль",
        nameKz: "Құпия сөзді енгізіңіз",
        nameEn: 'Enter password',
    },
    'Войти': {
        nameRu: "Войти",
        nameKz: "Кіру",
        nameEn: 'Sign in',
    },
    'Нет аккаунта?': {
        nameRu: "Нет аккаунта?",
        nameKz: "Аккаунт жоқ па?",
        nameEn: 'No account?',
    },
    'Зарегистрируйтесь': {
        nameRu: "Зарегистрируйтесь",
        nameKz: "Тіркеліңіз",
        nameEn: 'Register',
    },
    'Восстановить пароль': {
        nameRu: "Восстановить пароль",
        nameKz: "Құпия сөзді қалпына келтіру",
        nameEn: 'Reset password',
    },
    'Вернуться на главную': {
        nameRu: "Вернуться на главную",
        nameKz: "Басты бетке оралу",
        nameEn: 'Return to home',
    },
    'Регистрация': {
        nameRu: "Регистрация",
        nameKz: "Тіркеу",
        nameEn: 'Registration',
    },
    'Создайте аккаунт для регистрации дронов': {
        nameRu: "Создайте аккаунт для регистрации дронов",
        nameKz: "Дрондарды тіркеу үшін аккаунт жасаңыз",
        nameEn: 'Create an account to register drones',
    },
    'Тип лица': {
        nameRu: "Тип лица",
        nameKz: "Тұлға түрі",
        nameEn: 'Person type',
    },
    'Физическое лицо': {
        nameRu: "Физическое лицо",
        nameKz: "Жеке тұлға",
        nameEn: 'Individual',
    },
    'Юридическое лицо': {
        nameRu: "Юридическое лицо",
        nameKz: "Заңды тұлға",
        nameEn: 'Legal entity',
    },
    'Имя': {
        nameRu: "Имя",
        nameKz: "Аты",
        nameEn: 'First name',
    },
    'Введите имя': {
        nameRu: "Введите имя",
        nameKz: "Атыңызды енгізіңіз",
        nameEn: 'Enter first name',
    },
    'Фамилия': {
        nameRu: "Фамилия",
        nameKz: "Тегі",
        nameEn: 'Last name',
    },
    'Введите фамилию': {
        nameRu: "Введите фамилию",
        nameKz: "Тегіңізді енгізіңіз",
        nameEn: 'Enter last name',
    },
    'Организация': {
        nameRu: "Организация",
        nameKz: "Ұйым",
        nameEn: 'Organization',
    },
    'Введите название организации': {
        nameRu: "Введите название организации",
        nameKz: "Ұйым атауын енгізіңіз",
        nameEn: 'Enter organization name',
    },

    'Введите номер телефона': {
        nameRu: "Введите номер телефона",
        nameKz: "Телефон нөмірін енгізіңіз",
        nameEn: 'Enter phone number',
    },
    'Ошибка регистрации': {
        nameRu: "Ошибка регистрации",
        nameKz: "Тіркеу қатесі",
        nameEn: 'Registration error',
    },
    'Аккаунт создан, но профиль не создан. Обратитесь в поддержку.': {
        nameRu: "Аккаунт создан, но профиль не создан. Обратитесь в поддержку.",
        nameKz: "Аккаунт жасалды, бірақ профиль жасалмады. Қолдау қызметіне хабарласыңыз.",
        nameEn: 'The account was created, but the profile was not created. Contact support.',
    },
    'Регистрация успешна!': {
        nameRu: "Регистрация успешна!",
        nameKz: "Тіркеу сәтті!",
        nameEn: 'Registration successful!',
    },
    'Произошла ошибка при регистрации': {
        nameRu: "Произошла ошибка при регистрации",
        nameKz: "Тіркеу кезінде қате орын алды",
        nameEn: 'An error occurred during registration',
    },
    'Восстановление пароля': {
        nameRu: "Восстановление пароля",
        nameKz: "Құпия сөзді қалпына келтіру",
        nameEn: 'Password recovery',
    },
    'Введите email — мы отправим ссылку для сброса пароля': {
        nameRu: "Введите email — мы отправим ссылку для сброса пароля",
        nameKz: "Email енгізіңіз — біз құпия сөзді қалпына келтіру сілтемесін жібереміз",
        nameEn: 'Enter your email and we will send a password reset link',
    },
    'Письмо для восстановления пароля отправлено на ваш email': {
        nameRu: "Письмо для восстановления пароля отправлено на ваш email",
        nameKz: "Құпия сөзді қалпына келтіру хаты email-ға жіберілді",
        nameEn: 'A password recovery email has been sent to your email',
    },
    'Не удалось отправить письмо': {
        nameRu: "Не удалось отправить письмо",
        nameKz: "Хатты жіберу мүмкін болмады",
        nameEn: 'Failed to send email',
    },
    'Отправить ссылку': {
        nameRu: "Отправить ссылку",
        nameKz: "Сілтеме жіберу",
        nameEn: 'Send link',
    },
    'Вспомнили пароль?': {
        nameRu: "Вспомнили пароль?",
        nameKz: "Құпия сөзді есіңізге түсірдіңіз бе?",
        nameEn: 'Remembered your password?',
    },
    'Новый пароль': {
        nameRu: "Новый пароль",
        nameKz: "Жаңа құпия сөз",
        nameEn: 'New password',
    },
    'Введите новый пароль для вашего аккаунта': {
        nameRu: "Введите новый пароль для вашего аккаунта",
        nameKz: "Аккаунтыңызға жаңа құпия сөз енгізіңіз",
        nameEn: 'Enter a new password for your account',
    },
    'Подтвердите пароль': {
        nameRu: "Подтвердите пароль",
        nameKz: "Құпия сөзді растаңыз",
        nameEn: 'Confirm password',
    },
    'Введите пароль еще раз': {
        nameRu: "Введите пароль еще раз",
        nameKz: "Құпия сөзді қайта енгізіңіз",
        nameEn: 'Enter the password again',
    },
    'Пароли не совпадают': {
        nameRu: "Пароли не совпадают",
        nameKz: "Құпия сөздер сәйкес келмейді",
        nameEn: 'Passwords do not match',
    },
    'Пароль успешно обновлён': {
        nameRu: "Пароль успешно обновлён",
        nameKz: "Құпия сөз сәтті жаңартылды",
        nameEn: 'Password updated successfully',
    },
    'Не удалось обновить пароль': {
        nameRu: "Не удалось обновить пароль",
        nameKz: "Құпия сөзді жаңарту мүмкін болмады",
        nameEn: 'Failed to update password',
    },
    'Ссылка для восстановления пароля недействительна или истекла': {
        nameRu: "Ссылка для восстановления пароля недействительна или истекла",
        nameKz: "Құпия сөзді қалпына келтіру сілтемесі жарамсыз немесе мерзімі өткен",
        nameEn: 'The password recovery link is invalid or has expired',
    },
    'Ошибка при обработке ссылки восстановления': {
        nameRu: "Ошибка при обработке ссылки восстановления",
        nameKz: "Қалпына келтіру сілтемесін өңдеу кезінде қате",
        nameEn: 'Error processing recovery link',
    },
    'Для смены пароля перейдите по ссылке из письма': {
        nameRu: "Для смены пароля перейдите по ссылке из письма",
        nameKz: "Құпия сөзді өзгерту үшін хаттағы сілтемеге өтіңіз",
        nameEn: 'To change your password, follow the link from the email',
    },
    'Введите новый пароль': {
        nameRu: "Введите новый пароль",
        nameKz: "Жаңа құпия сөзді енгізіңіз",
        nameEn: 'Enter a new password',
    },
    'Минимум 8 символов': {
        nameRu: "Минимум 8 символов",
        nameKz: "Кем дегенде 8 таңба",
        nameEn: 'Minimum 8 characters',
    },

    'Повторите пароль': {
        nameRu: "Повторите пароль",
        nameKz: "Құпия сөзді қайталаңыз",
        nameEn: 'Repeat password',
    },
    'Сохранить пароль': {
        nameRu: "Сохранить пароль",
        nameKz: "Құпия сөзді сақтау",
        nameEn: 'Save password',
    },
    'Название организации': {
        nameRu: "Название организации",
        nameKz: "Ұйым атауы",
        nameEn: 'Organization name',
    },
    'Номер телефона': {
        nameRu: "Номер телефона",
        nameKz: "Телефон нөмірі",
        nameEn: 'Phone number',
    },
    'Повтор пароля': {
        nameRu: "Повтор пароля",
        nameKz: "Құпия сөзді қайталау",
        nameEn: 'Repeat password',
    },
    'Введите ИИН': {
        nameRu: "Введите ИИН",
        nameKz: "ЖСН енгізіңіз",
        nameEn: 'Enter IIN',
    },
    'ИИН должен быть из 12 цифр': {
        nameRu: "ИИН должен быть из 12 цифр",
        nameKz: "ЖСН 12 саннан тұруы керек",
        nameEn: 'IIN must contain 12 digits',
    },
    'Введите БИН': {
        nameRu: "Введите БИН",
        nameKz: "БСН енгізіңіз",
        nameEn: 'Enter BIN',
    },
    'БИН должен быть из 12 цифр': {
        nameRu: "БИН должен быть из 12 цифр",
        nameKz: "БСН 12 саннан тұруы керек",
        nameEn: 'BIN must contain 12 digits',
    },
    'Нужно согласие': {
        nameRu: "Нужно согласие",
        nameKz: "Келісім қажет",
        nameEn: 'Consent is required',
    },
    'Я ознакомлен(а) и согласен(на) с': {
        nameRu: "Я ознакомлен(а) и согласен(на) с",
        nameKz: "Мен танысып, келісемін",
        nameEn: 'I have read and agree to',
    },
    'согласием о предоставлении персональных данных': {
        nameRu: "согласием о предоставлении персональных данных",
        nameKz: "жеке деректерді беру туралы келісіммен",
        nameEn: 'the consent for providing personal data',
    },
    'Зарегистрироваться': {
        nameRu: "Зарегистрироваться",
        nameKz: "Тіркелу",
        nameEn: 'Register',
    },
    'Уже есть аккаунт?': {
        nameRu: "Уже есть аккаунт?",
        nameKz: "Аккаунт бар ма?",
        nameEn: 'Already have an account?',
    },
    'Войдите': {
        nameRu: "Войдите",
        nameKz: "Кіріңіз",
        nameEn: 'Sign in',
    },
    'Менее 0,25 кг': {
        nameRu: "Менее 0,25 кг",
        nameKz: "0,25 кг-нан аз",
        nameEn: 'Less than 0.25 kg',
    },
    'Свыше 0,25 кг': {
        nameRu: "Свыше 0,25 кг",
        nameKz: "0,25 кг-нан астам",
        nameEn: 'More than 0.25 kg',
    },
    'На срок 5 лет': {
        nameRu: "На срок 5 лет",
        nameKz: "5 жылға",
        nameEn: 'For a term of 5 years',
    },
    'На срок договора аренды': {
        nameRu: "На срок договора аренды",
        nameKz: "Жалға алу келісім-шарты мерзіміне",
        nameEn: 'For the lease term',
    },
    'Ожидает': {
        nameRu: "Ожидает",
        nameKz: "Күтуде",
        nameEn: 'Pending',
    },
    'Отклонено': {
        nameRu: "Отклонено",
        nameKz: "Қабылданбады",
        nameEn: 'Rejected',
    },
    'Завершено': {
        nameRu: "Завершено",
        nameKz: "Аяқталды",
        nameEn: 'Completed',
    },
    'Нельзя редактировать согласованные заявки': {
        nameRu: "Нельзя редактировать согласованные заявки",
        nameKz: "Келісілген өтініштерді өңдеуге болмайды",
        nameEn: 'Approved applications cannot be edited',
    },
    'Не удалось загрузить данные заявки для редактирования': {
        nameRu: "Не удалось загрузить данные заявки для редактирования",
        nameKz: "Өңдеу үшін өтініш деректерін жүктеу мүмкін болмады",
        nameEn: 'Failed to load application data for editing',
    },
    'Заявка успешно удалена': {
        nameRu: "Заявка успешно удалена",
        nameKz: "Өтініш сәтті жойылды",
        nameEn: 'Application deleted successfully',
    },
    'Ошибка при удалении заявки': {
        nameRu: "Ошибка при удалении заявки",
        nameKz: "Өтінішті жою кезінде қате",
        nameEn: 'Error deleting application',
    },
    'Дата': {
        nameRu: "Дата",
        nameKz: "Күні",
        nameEn: 'Date',
    },
    'Время': {
        nameRu: "Время",
        nameKz: "Уақыт",
        nameEn: 'Time',
    },
    'Дрон': {
        nameRu: "Дрон",
        nameKz: "Дрон",
        nameEn: 'Drone',
    },
    'Сектор': {
        nameRu: "Сектор",
        nameKz: "Сектор",
        nameEn: 'Sector',
    },
    'Высота': {
        nameRu: "Высота",
        nameKz: "Биіктік",
        nameEn: 'Altitude',
    },
    'Назначение': {
        nameRu: "Назначение",
        nameKz: "Мақсат",
        nameEn: 'Purpose',
    },
    'Действия': {
        nameRu: "Действия",
        nameKz: "Әрекеттер",
        nameEn: 'Actions',
    },
    'Открыть паспорт полета': {
        nameRu: "Открыть паспорт полета",
        nameKz: "Ұшу паспортын ашу",
        nameEn: 'Open flight passport',
    },
    'Редактировать': {
        nameRu: "Редактировать",
        nameKz: "Өңдеу",
        nameEn: 'Edit',
    },
    'Удалить': {
        nameRu: "Удалить",
        nameKz: "Жою",
        nameEn: 'Delete',
    },
    'Аватар загружен': {
        nameRu: "Аватар загружен",
        nameKz: "Аватар жүктелді",
        nameEn: 'Avatar uploaded',
    },
    'Ошибка загрузки аватара': {
        nameRu: "Ошибка загрузки аватара",
        nameKz: "Аватарды жүктеу қатесі",
        nameEn: 'Error uploading avatar',
    },
    'Максимальное количество файлов: 5': {
        nameRu: "Максимальное количество файлов: 5",
        nameKz: "Файлдардың максималды саны: 5",
        nameEn: 'Maximum number of files: 5',
    },
    'Ошибка загрузки файлов': {
        nameRu: "Ошибка загрузки файлов",
        nameKz: "Файлдарды жүктеу қатесі",
        nameEn: 'Error uploading files',
    },
    'Файл скачан': {
        nameRu: "Файл скачан",
        nameKz: "Файл жүктелді",
        nameEn: 'File downloaded',
    },
    'Ошибка скачивания файла': {
        nameRu: "Ошибка скачивания файла",
        nameKz: "Файлды жүктеу қатесі",
        nameEn: 'Error downloading file',
    },
    'Файл не найден': {
        nameRu: "Файл не найден",
        nameKz: "Файл табылмады",
        nameEn: 'File not found',
    },
    'Файл удален': {
        nameRu: "Файл удален",
        nameKz: "Файл жойылды",
        nameEn: 'File deleted',
    },
    'Ошибка удаления файла': {
        nameRu: "Ошибка удаления файла",
        nameKz: "Файлды жою қатесі",
        nameEn: 'Error deleting file',
    },
    'Изображение дрона загружено': {
        nameRu: "Изображение дрона загружено",
        nameKz: "Дрон суреті жүктелді",
        nameEn: 'Drone image uploaded',
    },
    'Ошибка загрузки изображения дрона': {
        nameRu: "Ошибка загрузки изображения дрона",
        nameKz: "Дрон суретін жүктеу қатесі",
        nameEn: 'Error uploading drone image',
    },
    'Телефон обязателен для заполнения': {
        nameRu: "Телефон обязателен для заполнения",
        nameKz: "Телефон толтыру үшін міндетті",
        nameEn: 'Phone is required',
    },
    'Введите корректный email': {
        nameRu: "Введите корректный email",
        nameKz: "Дұрыс email енгізіңіз",
        nameEn: 'Enter a valid email',
    },
    'На новый email отправлено письмо для подтверждения. Проверьте почту.': {
        nameRu: "На новый email отправлено письмо для подтверждения. Проверьте почту.",
        nameKz: "Жаңа email-ға растау үшін хат жіберілді. Поштаны тексеріңіз.",
        nameEn: 'A confirmation email has been sent to the new email address. Check your inbox.',
    },
    'Профиль обновлен. Подтвердите новый email, перейдя по ссылке в письме.': {
        nameRu: "Профиль обновлен. Подтвердите новый email, перейдя по ссылке в письме.",
        nameKz: "Профиль жаңартылды. Хаттағы сілтеме арқылы жаңа email-ді растаңыз.",
        nameEn: 'Profile updated. Confirm the new email by following the link in the email.',
    },
    'Профиль обновлен': {
        nameRu: "Профиль обновлен",
        nameKz: "Профиль жаңартылды",
        nameEn: 'Profile updated',
    },
    'Ошибка сохранения профиля': {
        nameRu: "Ошибка сохранения профиля",
        nameKz: "Профильді сақтау қатесі",
        nameEn: 'Error saving profile',
    },
    'История действий': {
        nameRu: "История действий",
        nameKz: "Әрекеттер тарихы",
        nameEn: 'Activity history',
    },
    'Редактировать профиль': {
        nameRu: "Редактировать профиль",
        nameKz: "Профильді өңдеу",
        nameEn: 'Edit profile',
    },
    'Зарегистрировано дронов': {
        nameRu: "Зарегистрировано дронов",
        nameKz: "Тіркелген дрондар",
        nameEn: 'Registered drones',
    },
    'Запланировано полетов': {
        nameRu: "Запланировано полетов",
        nameKz: "Жоспарланған ұшулар",
        nameEn: 'Scheduled flights',
    },
    'Одобренных полетов': {
        nameRu: "Одобренных полетов",
        nameKz: "Мақұлданған ұшулар",
        nameEn: 'Approved flights',
    },
    'Обновить список дронов': {
        nameRu: "Обновить список дронов",
        nameKz: "Дрондар тізімін жаңарту",
        nameEn: 'Refresh drone list',
    },
    'Через портал e.license': {
        nameRu: "Через портал e.license",
        nameKz: "e.license порталы арқылы",
        nameEn: 'Via the e.license portal',
    },
    'Через форму': {
        nameRu: "Через форму",
        nameKz: "Форма арқылы",
        nameEn: 'Via form',
    },
    'Нет зарегистрированных дронов': {
        nameRu: "Нет зарегистрированных дронов",
        nameKz: "Тіркелген дрондар жоқ",
        nameEn: 'No registered drones',
    },
    'Не указана': {
        nameRu: "Не указана",
        nameKz: "Көрсетілмеген",
        nameEn: 'Not specified',
    },

    'Поиск по дрону, сектору...': {
        nameRu: "Поиск по дрону, сектору...",
        nameKz: "Дрон, сектор бойынша іздеу...",
        nameEn: 'Search by drone, sector...',
    },
    'Очистить': {
        nameRu: "Очистить",
        nameKz: "Тазалау",
        nameEn: 'Clear',
    },
    'Редактировать изображение дрона': {
        nameRu: "Редактировать изображение дрона",
        nameKz: "Дрон суретін өңдеу",
        nameEn: 'Edit drone image',
    },
    'Применить': {
        nameRu: "Применить",
        nameKz: "Қолдану",
        nameEn: 'Apply',
    },
    'Отмена': {
        nameRu: "Отмена",
        nameKz: "Болдырмау",
        nameEn: 'Cancel',
    },
    'Загрузка...': {
        nameRu: "Загрузка...",
        nameKz: "Жүктелуде...",
        nameEn: 'Loading...',
    },
    'Загрузить фото': {
        nameRu: "Загрузить фото",
        nameKz: "Фото жүктеу",
        nameEn: 'Upload photo',
    },
    'Скачать': {
        nameRu: "Скачать",
        nameKz: "Жүктеу",
        nameEn: 'Download',
    },
    'Удаление файла': {
        nameRu: "Удаление файла",
        nameKz: "Файлды жою",
        nameEn: 'File deletion',
    },
    'Редактирование профиля': {
        nameRu: "Редактирование профиля",
        nameKz: "Профильді өңдеу",
        nameEn: 'Profile editing',
    },
    'Сохранить': {
        nameRu: "Сохранить",
        nameKz: "Сақтау",
        nameEn: 'Save',
    },
    'Мои дроны': {
        nameRu: "Мои дроны",
        nameKz: "Менің дрондарым",
        nameEn: 'My drones',
    },
    'Весовая категория:': {
        nameRu: "Весовая категория:",
        nameKz: "Салмақ категориясы:",
        nameEn: 'Weight category:',
    },
    'Категория': {
        nameRu: "Категория",
        nameKz: "Категориясы",
        nameEn: 'Category',
    },
    'из': {
        nameRu: "из",
        nameKz: "дан",
        nameEn: 'of',
    },
    'Фильтры и поиск': {
        nameRu: "Фильтры и поиск",
        nameKz: "Сүзгілер және іздеу",
        nameEn: 'Filters and search',
    },
    'Все статусы': {
        nameRu: "Все статусы",
        nameKz: "Барлық мәртебелер",
        nameEn: 'All statuses',
    },
    'Все сектора': {
        nameRu: "Все сектора",
        nameKz: "Барлық секторлар",
        nameEn: 'All sectors',
    },

    'Запланированные полеты': {
        nameRu: "Запланированные полеты",
        nameKz: "Жоспарланған ұшулар",
        nameEn: 'Scheduled flights',
    },
    'S/N:': {
        nameRu: "S/N:",
        nameKz: "S/N:",
        nameEn: 'S/N:',
    },
    'Детальная информация о беспилотной авиационной системе': {
        nameRu: "Детальная информация о беспилотной авиационной системе",
        nameKz: "Пилотсыз авиациялық жүйе туралы толық ақпарат",
        nameEn: 'Detailed information about the unmanned aircraft system',
    },
    'Пред. бортовой №:': {
        nameRu: "Пред. бортовой №:",
        nameKz: "Алдыңғы борт нөмірі:",
        nameEn: 'Prev. registration No.:',
    },
    'Грузоподъемность:': {
        nameRu: "Грузоподъемность:",
        nameKz: "Жүк көтергіштігі:",
        nameEn: 'Payload capacity:',
    },
    'Дата выпуска:': {
        nameRu: "Дата выпуска:",
        nameKz: "Шығарылған күні:",
        nameEn: 'Manufacture date:',
    },
    'Собственник:': {
        nameRu: "Собственник:",
        nameKz: "Иесі:",
        nameEn: 'Owner:',
    },
    'Срок действия:': {
        nameRu: "Срок действия:",
        nameKz: "Мерзімі:",
        nameEn: 'Validity period:',
    },
    'Производитель (RU):': {
        nameRu: "Производитель (RU):",
        nameKz: "Өндіруші (RU):",
        nameEn: 'Manufacturer (RU):',
    },
    'Документы:': {
        nameRu: "Документы:",
        nameKz: "Құжаттар:",
        nameEn: 'Documents:',
    },
    'Загрузить документы': {
        nameRu: "Загрузить документы",
        nameKz: "Құжаттарды жүктеу",
        nameEn: 'Upload documents',
    },
    'Нет загруженных документов': {
        nameRu: "Нет загруженных документов",
        nameKz: "Жүктелген құжаттар жоқ",
        nameEn: 'No uploaded documents',
    },
    'Вы уверены, что хотите удалить файл': {
        nameRu: "Вы уверены, что хотите удалить файл",
        nameKz: "Файлды жоюға сенімдісіз бе",
        nameEn: 'Are you sure you want to delete the file',
    },
    '?': {
        nameRu: "?",
        nameKz: "?",
        nameEn: '?',
    },

    'Загрузить аватар': {
        nameRu: "Загрузить аватар",
        nameKz: "Аватар жүктеу",
        nameEn: 'Upload avatar',
    },

    'Вы уверены, что хотите удалить эту заявку на полет?': {
        nameRu: "Вы уверены, что хотите удалить эту заявку на полет?",
        nameKz: "Бұл ұшу өтінішін жоюға сенімдісіз бе?",
        nameEn: 'Are you sure you want to delete this flight application?',
    },
    'БАС': {
        nameRu: "БАС",
        nameKz: "БАҚ",
        nameEn: 'UAS',
    },
    'Беспилотная авиационная система': {
        nameRu: "Беспилотная авиационная система",
        nameKz: "Пилотсыз авиациялық жүйе",
        nameEn: 'Unmanned aircraft system',
    },
    'Форма очищена': {
        nameRu: "Форма очищена",
        nameKz: "Форма тазаланды",
        nameEn: 'Form cleared',
    },
    'Пользователь не найден': {
        nameRu: "Пользователь не найден",
        nameKz: "Пайдаланушы табылмады",
        nameEn: 'User not found',
    },
    'Введите максимальную взлетную массу дрона': {
        nameRu: "Введите максимальную взлетную массу дрона",
        nameKz: "Дронның максималды ұшу салмағын енгізіңіз",
        nameEn: 'Enter the drone maximum takeoff weight',
    },
    'Укажите дату выпуска БАС': {
        nameRu: "Укажите дату выпуска БАС",
        nameKz: "БАҚ шығарылған күнін көрсетіңіз",
        nameEn: 'Specify the UAS manufacture date',
    },
    'Необходимо согласиться со всеми условиями': {
        nameRu: "Необходимо согласиться со всеми условиями",
        nameKz: "Барлық шарттармен келісу қажет",
        nameEn: 'You must agree to all terms',
    },
    'Регистрация дрона': {
        nameRu: "Регистрация дрона",
        nameKz: "Дронды тіркеу",
        nameEn: 'Drone registration',
    },
    'Дрон успешно зарегистрирован': {
        nameRu: "Дрон успешно зарегистрирован",
        nameKz: "Дрон сәтті тіркелді",
        nameEn: 'Drone registered successfully',
    },
    'Ваш дрон': {
        nameRu: "Ваш дрон",
        nameKz: "Сіздің дроныңыз",
        nameEn: 'Your drone',
    },
    'успешно зарегистрирован в системе.': {
        nameRu: "успешно зарегистрирован в системе.",
        nameKz: "жүйеде сәтті тіркелді.",
        nameEn: 'has been successfully registered in the system.',
    },
    'Без названия': {
        nameRu: "Без названия",
        nameKz: "Атаусыз",
        nameEn: 'Untitled',
    },
    'Без номера': {
        nameRu: "Без номера",
        nameKz: "Нөмірсіз",
        nameEn: 'No number',
    },
    'Ошибка регистрации дрона': {
        nameRu: "Ошибка регистрации дрона",
        nameKz: "Дронды тіркеу қатесі",
        nameEn: 'Drone registration error',
    },
    'Регистрация беспилотной авиационной системы': {
        nameRu: "Регистрация беспилотной авиационной системы",
        nameKz: "Пилотсыз авиациялық жүйені тіркеу",
        nameEn: 'Unmanned aircraft system registration',
    },
    'Этап 1: Основные сведения': {
        nameRu: "Этап 1: Основные сведения",
        nameKz: "Кезең 1: Негізгі мәліметтер",
        nameEn: 'Step 1: Basic information',
    },
    'Этап 2: Подтверждение': {
        nameRu: "Этап 2: Подтверждение",
        nameKz: "Кезең 2: Растау",
        nameEn: 'Step 2: Confirmation',
    },
    'Свидетельство о постановке на учет': {
        nameRu: "Свидетельство о постановке на учет",
        nameKz: "Есепке алу туралы куәлік",
        nameEn: 'Registration certificate',
    },
    'Весовая категория 0,25 кг менее или свыше 0,25 кг': {
        nameRu: "Весовая категория 0,25 кг менее или свыше 0,25 кг",
        nameKz: "Салмақ категориясы 0,25 кг-нан аз немесе 0,25 кг-нан астам",
        nameEn: 'Weight category: less than 0.25 kg or more than 0.25 kg',
    },
    'Выберите весовую категорию': {
        nameRu: "Выберите весовую категорию",
        nameKz: "Салмақ категориясын таңдаңыз",
        nameEn: 'Select weight category',
    },
    'Выберите категорию': {
        nameRu: "Выберите категорию",
        nameKz: "Категорияны таңдаңыз",
        nameEn: 'Select category',
    },
    'Я являюсь собственником': {
        nameRu: "Я являюсь собственником",
        nameKz: "Мен иесімін",
        nameEn: 'I am the owner',
    },
    'Укажите статус собственности': {
        nameRu: "Укажите статус собственности",
        nameKz: "Меншік мәртебесін көрсетіңіз",
        nameEn: 'Specify ownership status',
    },
    'Да': {
        nameRu: "Да",
        nameKz: "Иә",
        nameEn: 'Yes',
    },
    'Нет': {
        nameRu: "Нет",
        nameKz: "Жоқ",
        nameEn: 'No',
    },
    'Присвоенный уполномоченной организацией учетный номер декларации или сертификата соответствия': {
        nameRu: "Присвоенный уполномоченной организацией учетный номер декларации или сертификата соответствия",
        nameKz: "Уәкілетті ұйым тағайындаған декларация немесе сәйкестік сертификатының есептік нөмірі",
        nameEn: 'Registration number of the declaration or certificate of conformity assigned by the authorized organization',
    },
    'Введите номер декларации': {
        nameRu: "Введите номер декларации",
        nameKz: "Декларация нөмірін енгізіңіз",
        nameEn: 'Enter declaration number',
    },
    'Получение учетного номера осуществляется заявителем самостоятельно в соответствии с требованиями Правил использования беспилотных авиационных систем': {
        nameRu: "Получение учетного номера осуществляется заявителем самостоятельно в соответствии с требованиями Правил использования беспилотных авиационных систем",
        nameKz: "Есептік нөмірді алу өтініш берушінің өзі тарапынан пилотсыз авиациялық жүйелерді пайдалану ережелерінің талаптарына сәйкес жүзеге асырылады",
        nameEn: 'The applicant obtains the registration number independently in accordance with the requirements of the Rules for the Use of Unmanned Aircraft Systems',
    },
    'Предыдущий бортовой номер (при его наличии)': {
        nameRu: "Предыдущий бортовой номер (при его наличии)",
        nameKz: "Алдыңғы борт нөмірі (бар болса)",
        nameEn: 'Previous registration number (if any)',
    },
    'Введите предыдущий бортовой номер': {
        nameRu: "Введите предыдущий бортовой номер",
        nameKz: "Алдыңғы борт нөмірін енгізіңіз",
        nameEn: 'Enter previous registration number',
    },
    'Укажите ранее присвоенный бортовой номер БАС': {
        nameRu: "Укажите ранее присвоенный бортовой номер БАС",
        nameKz: "Бұрын тағайындалған БАҚ борт нөмірін көрсетіңіз",
        nameEn: 'Specify the previously assigned UAS registration number',
    },
    'Производитель': {
        nameRu: "Производитель",
        nameKz: "Өндіруші",
        nameEn: 'Manufacturer',
    },
    'Введите название производителя на русском': {
        nameRu: "Введите название производителя на русском",
        nameKz: "Өндіруші атауын орысша енгізіңіз",
        nameEn: 'Enter the manufacturer name in Russian',
    },
    'Полное юридическое наименование': {
        nameRu: "Полное юридическое наименование",
        nameKz: "Толық заңды атауы",
        nameEn: 'Full legal name',
    },
    'Введите название производителя на казахском': {
        nameRu: "Введите название производителя на казахском",
        nameKz: "Өндіруші атауын қазақша енгізіңіз",
        nameEn: 'Enter the manufacturer name in Kazakh',
    },
    'Введите название производителя на английском': {
        nameRu: "Введите название производителя на английском",
        nameKz: "Өндіруші атауын ағылшынша енгізіңіз",
        nameEn: 'Enter the manufacturer name in English',
    },
    'Full legal name': {
        nameRu: "Full legal name",
        nameKz: "Толық заңды атауы",
        nameEn: 'Full legal name',
    },
    'Введите модель БАС': {
        nameRu: "Введите модель БАС",
        nameKz: "БАҚ моделін енгізіңіз",
        nameEn: 'Enter UAS model',
    },
    'Полное наименование модели': {
        nameRu: "Полное наименование модели",
        nameKz: "Модельдің толық атауы",
        nameEn: 'Full model name',
    },
    'Укажите полное наименование модели в соответствии с согласованной декларацией': {
        nameRu: "Укажите полное наименование модели в соответствии с согласованной декларацией",
        nameKz: "Келісілген декларацияға сәйкес модельдің толық атауын көрсетіңіз",
        nameEn: 'Specify the full model name according to the approved declaration',
    },
    'Серийный номер (макс 100 символов)': {
        nameRu: "Серийный номер (макс 100 символов)",
        nameKz: "Сериялық нөмір (макс 100 таңба)",
        nameEn: 'Serial number (max 100 characters)',
    },
    'Максимум 100 символов': {
        nameRu: "Максимум 100 символов",
        nameKz: "Максимум 100 таңба",
        nameEn: 'Maximum 100 characters',
    },
    'Дата выпуска': {
        nameRu: "Дата выпуска",
        nameKz: "Шығарылған күні",
        nameEn: 'Manufacture date',
    },
    'Выберите дату выпуска': {
        nameRu: "Выберите дату выпуска",
        nameKz: "Шығарылған күнін таңдаңыз",
        nameEn: 'Select manufacture date',
    },
    'дд.мм.гггг': {
        nameRu: "дд.мм.гггг",
        nameKz: "кк.аа.жжжж",
        nameEn: 'dd.mm.yyyy',
    },
    'Максимальная взлетная масса в кг': {
        nameRu: "Максимальная взлетная масса в кг",
        nameKz: "Максималды ұшу салмағы (кг)",
        nameEn: 'Maximum takeoff weight in kg',
    },
    'Введите максимальную взлетную массу': {
        nameRu: "Введите максимальную взлетную массу",
        nameKz: "Максималды ұшу салмағын енгізіңіз",
        nameEn: 'Enter maximum takeoff weight',
    },
    'Выберите тип БАС': {
        nameRu: "Выберите тип БАС",
        nameKz: "БАҚ түрін таңдаңыз",
        nameEn: 'Select UAS type',
    },
    'Выберите тип': {
        nameRu: "Выберите тип",
        nameKz: "Түрін таңдаңыз",
        nameEn: 'Select type',
    },
    'Вертолетный': {
        nameRu: "Вертолетный",
        nameKz: "Тікұшақтық",
        nameEn: 'Helicopter',
    },
    'Срок действия': {
        nameRu: "Срок действия",
        nameKz: "Мерзімі",
        nameEn: 'Validity period',
    },
    'Выберите срок': {
        nameRu: "Выберите срок",
        nameKz: "Мерзімін таңдаңыз",
        nameEn: 'Select term',
    },
    'Далее': {
        nameRu: "Далее",
        nameKz: "Келесі",
        nameEn: 'Next',
    },

    'Зарегистрировать': {
        nameRu: "Зарегистрировать",
        nameKz: "Тіркеу",
        nameEn: 'Register',
    },
    'Сведения о подтверждении': {
        nameRu: "Сведения о подтверждении",
        nameKz: "Растау туралы мәліметтер",
        nameEn: 'Confirmation details',
    },
    'Обязательно': {
        nameRu: "Обязательно",
        nameKz: "Міндетті",
        nameEn: 'Required',
    },
    'Отсутствия обременения на заявленную БАС': {
        nameRu: "Отсутствия обременения на заявленную БАС",
        nameKz: "Өтініш берілген БАҚ-та обременение жоқ",
        nameEn: 'Absence of encumbrance on the declared UAS',
    },
    'Подтверждаю отсутствие каких-либо обременений на заявленную БАС': {
        nameRu: "Подтверждаю отсутствие каких-либо обременений на заявленную БАС",
        nameKz: "Өтініш берілген БАҚ-та кез келген обременение жоқ екенін растаймын",
        nameEn: 'I confirm that there are no encumbrances on the declared UAS',
    },
    'Согласен на использование сведений, составляющих охраняемую законом тайну': {
        nameRu: "Согласен на использование сведений, составляющих охраняемую законом тайну",
        nameKz: "Заңмен қорғалатын құпияны құрайтын мәліметтерді пайдалануға келісемін",
        nameEn: 'I consent to the use of information constituting a legally protected secret',
    },
    'Согласен на использование сведений, составляющих охраняемую законом тайну, содержащихся в информационных системах': {
        nameRu: "Согласен на использование сведений, составляющих охраняемую законом тайну, содержащихся в информационных системах",
        nameKz: "Ақпараттық жүйелердегі заңмен қорғалатын құпияны құрайтын мәліметтерді пайдалануға келісемін",
        nameEn: 'I consent to the use of information constituting a legally protected secret contained in information systems',
    },
    'Я заявляю, что приведенная в настоящей заявке сведения верны во всех отношениях': {
        nameRu: "Я заявляю, что приведенная в настоящей заявке сведения верны во всех отношениях",
        nameKz: "Мен осы өтініште келтірілген мәліметтердің барлық жағынан дұрыс екенін мәлімдеймін",
        nameEn: 'I declare that the information provided in this application is correct in all respects',
    },
    'Я заявляю, что приведенная в настоящей заявке сведения и (или) приложенные к ней документы верны во всех отношениях': {
        nameRu: "Я заявляю, что приведенная в настоящей заявке сведения и (или) приложенные к ней документы верны во всех отношениях",
        nameKz: "Мен осы өтініште келтірілген мәліметтер мен (немесе) оған тіркелген құжаттардың барлық жағынан дұрыс екенін мәлімдеймін",
        nameEn: 'I declare that the information provided in this application and/or the documents attached to it are correct in all respects',
    },
    'Сведения о': {
        nameRu: "Сведения о",
        nameKz: "Туралы мәліметтер",
        nameEn: 'Information about',
    },
    'Детали заявки на полет': {
        nameRu: "Детали заявки на полет",
        nameKz: "Ұшу өтінішінің мәліметтері",
        nameEn: 'Flight application details',
    },
    'Заявка одобрена модератором': {
        nameRu: "Заявка одобрена модератором",
        nameKz: "Өтініш модератормен мақұлданды",
        nameEn: 'Application approved by moderator',
    },
    'Ваша заявка была одобрена модератором, разрешение получено.': {
        nameRu: "Ваша заявка была одобрена модератором, разрешение получено.",
        nameKz: "Сіздің өтінішіңіз модератормен мақұлданды, рұқсат алынды.",
        nameEn: 'Your application was approved by the moderator; the permit has been received.',
    },
    'Модератор отклонил заявку': {
        nameRu: "Модератор отклонил заявку",
        nameKz: "Модератор өтінішті қабылдамады",
        nameEn: 'The moderator rejected the application',
    },
    'Ошибка при заполнении полетного листа': {
        nameRu: "Ошибка при заполнении полетного листа",
        nameKz: "Ұшу парағыңызды толтыру кезінде қате",
        nameEn: 'Error completing the flight sheet',
    },
    'Заявка находится на рассмотрении модератора': {
        nameRu: "Заявка находится на рассмотрении модератора",
        nameKz: "Өтініш модератордың қарауында",
        nameEn: 'The application is under moderator review',
    },
    'Ваша заявка находится на рассмотрении, ожидайте решения модератора.': {
        nameRu: "Ваша заявка находится на рассмотрении, ожидайте решения модератора.",
        nameKz: "Сіздің өтінішіңіз қарауда, модератордың шешімін күтіңіз.",
        nameEn: "Your application is under review. Please wait for the moderator's decision.",
    },
    'Секторы': {
        nameRu: "Секторы",
        nameKz: "Секторлар",
        nameEn: 'Sectors',
    },
    'Пользователь не авторизован': {
        nameRu: "Пользователь не авторизован",
        nameKz: "Пайдаланушы авторизацияланбаған",
        nameEn: 'User is not authorized',
    },
    'Подача заявки на полет': {
        nameRu: "Подача заявки на полет",
        nameKz: "Ұшу өтінішін беру",
        nameEn: 'Submit flight application',
    },
    'Не удалось загрузить логи': {
        nameRu: "Не удалось загрузить логи",
        nameKz: "Логтарды жүктеу мүмкін болмады",
        nameEn: 'Failed to load logs',
    },
    'Закрыть': {
        nameRu: "Закрыть",
        nameKz: "Жабу",
        nameEn: 'Close',
    },
    'Загрузка истории действий...': {
        nameRu: "Загрузка истории действий...",
        nameKz: "Әрекеттер тарихы жүктелуде...",
        nameEn: 'Loading activity history...',
    },
    'Нет записей о действиях': {
        nameRu: "Нет записей о действиях",
        nameKz: "Әрекеттер туралы жазбалар жоқ",
        nameEn: 'No activity records',
    },
    'Будущее авиации': {
        nameRu: "Будущее авиации",
        nameKz: "Авиацияның болашағы",
        nameEn: 'The future of aviation',
    },
    'Регистрация и управление полетами дронов в Казахстане': {
        nameRu: "Регистрация и управление полетами дронов в Казахстане",
        nameKz: "Қазақстанда дрондардың ұшуын тіркеу және басқару",
        nameEn: 'Drone registration and flight management in Kazakhstan',
    },
    'Инновационная платформа для безопасного и законного использования беспилотных летательных аппаратов': {
        nameRu: "Инновационная платформа для безопасного и законного использования беспилотных летательных аппаратов",
        nameKz: "Пилотсыз ұшу аппараттарын қауіпсіз және заңды пайдалануға арналған инновациялық платформа",
        nameEn: 'An innovative platform for safe and legal use of unmanned aircraft',
    },
    'Зарегистрировать дрон': {
        nameRu: "Зарегистрировать дрон",
        nameKz: "Дронды тіркеу",
        nameEn: 'Register a drone',
    },
    'Узнать больше': {
        nameRu: "Узнать больше",
        nameKz: "Көбірек білу",
        nameEn: 'Learn more',
    },
    'Требуется авторизация': {
        nameRu: "Требуется авторизация",
        nameKz: "Авторизация қажет",
        nameEn: 'Authorization required',
    },
    'Для регистрации дрона необходима авторизация в системе': {
        nameRu: "Для регистрации дрона необходима авторизация в системе",
        nameKz: "Дронды тіркеу үшін жүйеде авторизация қажет",
        nameEn: 'System authorization is required to register a drone',
    },
    'Авторизоваться': {
        nameRu: "Авторизоваться",
        nameKz: "Авторизациялау",
        nameEn: 'Sign in',
    },
    'Выберите способ регистрации дрона': {
        nameRu: "Выберите способ регистрации дрона",
        nameKz: "Дронды тіркеу әдісін таңдаңыз",
        nameEn: 'Select a drone registration method',
    },
    'Продолжить': {
        nameRu: "Продолжить",
        nameKz: "Жалғастыру",
        nameEn: 'Continue',
    },
    'Через личный кабинет': {
        nameRu: "Через личный кабинет",
        nameKz: "Жеке кабинет арқылы",
        nameEn: 'Via personal account',
    },
    'Регистрация дрона через форму в личном кабинете': {
        nameRu: "Регистрация дрона через форму в личном кабинете",
        nameKz: "Жеке кабинеттегі форма арқылы дронды тіркеу",
        nameEn: 'Drone registration via the form in the personal account',
    },
    'Регистрация дрона через официальный портал e.license.kz': {
        nameRu: "Регистрация дрона через официальный портал e.license.kz",
        nameKz: "Ресми e.license.kz порталы арқылы дронды тіркеу",
        nameEn: 'Drone registration via the official e.license.kz portal',
    },
    'Безопасность': {
        nameRu: "Безопасность",
        nameKz: "Қауіпсіздік",
        nameEn: 'Safety',
    },
    'Полное соответствие законодательству Казахстана о беспилотных летательных аппаратах': {
        nameRu: "Полное соответствие законодательству Казахстана о беспилотных летательных аппаратах",
        nameKz: "Қазақстанның пилотсыз ұшу аппараттары туралы заңнамасына толық сәйкестік",
        nameEn: 'Full compliance with Kazakhstan legislation on unmanned aircraft',
    },
    'Интерактивные карты': {
        nameRu: "Интерактивные карты",
        nameKz: "Интерактивті карталар",
        nameEn: 'Interactive maps',
    },
    'Визуализация запретных и ограниченных зон для планирования безопасных маршрутов': {
        nameRu: "Визуализация запретных и ограниченных зон для планирования безопасных маршрутов",
        nameKz: "Қауіпсіз маршруттарды жоспарлау үшін тыйым салынған және шектеулі аймақтарды визуализациялау",
        nameEn: 'Visualization of prohibited and restricted zones for planning safe routes',
    },
    'Быстрая регистрация': {
        nameRu: "Быстрая регистрация",
        nameKz: "Жылдам тіркеу",
        nameEn: 'Fast registration',
    },
    'Простая и удобная процедура регистрации дронов и подачи заявок на полеты': {
        nameRu: "Простая и удобная процедура регистрации дронов и подачи заявок на полеты",
        nameKz: "Дрондарды тіркеу және ұшу өтініштерін беру үшін қарапайым және ыңғайлы процедура",
        nameEn: 'A simple and convenient procedure for drone registration and flight applications',
    },
    'Для всех': {
        nameRu: "Для всех",
        nameKz: "Барлығына",
        nameEn: 'For everyone',
    },
    'Подходит как для коммерческих, так и для исследовательских целей': {
        nameRu: "Подходит как для коммерческих, так и для исследовательских целей",
        nameKz: "Коммерциялық және зерттеу мақсаттарына да қолайлы",
        nameEn: 'Suitable for both commercial and research purposes',
    },
    'Преимущества платформы': {
        nameRu: "Преимущества платформы",
        nameKz: "Платформаның артықшылықтары",
        nameEn: 'Platform benefits',
    },
    'Все необходимое для легального и безопасного использования дронов в одном месте': {
        nameRu: "Все необходимое для легального и безопасного использования дронов в одном месте",
        nameKz: "Дрондарды заңды және қауіпсіз пайдалану үшін барлық қажетті нәрселер бір жерде",
        nameEn: 'Everything needed for legal and safe drone use in one place',
    },
    'Платформа для регистрации дронов и управления полетами в Казахстане.': {
        nameRu: "Платформа для регистрации дронов и управления полетами в Казахстане.",
        nameKz: "Қазақстанда дрондарды тіркеу және ұшуларды басқаруға арналған платформа.",
        nameEn: 'A platform for drone registration and flight management in Kazakhstan.',
    },
    'Услуги': {
        nameRu: "Услуги",
        nameKz: "Қызметтер",
        nameEn: 'Services',
    },
    'Карта зон': {
        nameRu: "Карта зон",
        nameKz: "Аймақтар картасы",
        nameEn: 'Zone map',
    },
    'Информация': {
        nameRu: "Информация",
        nameKz: "Ақпарат",
        nameEn: 'Information',
    },
    'Контакты': {
        nameRu: "Контакты",
        nameKz: "Байланыстар",
        nameEn: 'Contacts',
    },
    'г. Алматы': {
        nameRu: "г. Алматы",
        nameKz: "Алматы қ.",
        nameEn: 'Almaty',
    },
    'Все права защищены.': {
        nameRu: "Все права защищены.",
        nameKz: "Барлық құқықтар қорғалған.",
        nameEn: 'All rights reserved.',
    },
    'Нужно ли регистрировать дрон в Казахстане?': {
        nameRu: "Нужно ли регистрировать дрон в Казахстане?",
        nameKz: "Қазақстанда дронды тіркеу керек пе?",
        nameEn: 'Do drones need to be registered in Kazakhstan?',
    },
    'Да, все дроны весом более 250 грамм подлежат обязательной регистрации в соответствии с законодательством Республики Казахстан.': {
        nameRu: "Да, все дроны весом более 250 грамм подлежат обязательной регистрации в соответствии с законодательством Республики Казахстан.",
        nameKz: "Иә, 250 грамнан астам салмағы бар барлық дрондар Қазақстан Республикасының заңнамасына сәйкес міндетті тіркеуден өтуге тиіс.",
        nameEn: 'Yes, all drones weighing more than 250 grams must be registered in accordance with the legislation of the Republic of Kazakhstan.',
    },
    'Сколько времени занимает регистрация?': {
        nameRu: "Сколько времени занимает регистрация?",
        nameKz: "Тіркеу қанша уақыт алады?",
        nameEn: 'How long does registration take?',
    },
    'Процесс регистрации дрона занимает от 1 до 3 рабочих дней после подачи всех необходимых документов.': {
        nameRu: "Процесс регистрации дрона занимает от 1 до 3 рабочих дней после подачи всех необходимых документов.",
        nameKz: "Дронды тіркеу процесі барлық қажетті құжаттарды тапсырғаннан кейін 1-3 жұмыс күнін алады.",
        nameEn: 'The drone registration process takes 1 to 3 business days after all required documents are submitted.',
    },
    'Где можно летать на дроне?': {
        nameRu: "Где можно летать на дроне?",
        nameKz: "Дронмен қайда ұшуға болады?",
        nameEn: 'Where can you fly a drone?',
    },
    'Полеты разрешены в специально отведенных зонах. На нашей платформе есть интерактивная карта с обозначением запретных и ограниченных зон.': {
        nameRu: "Полеты разрешены в специально отведенных зонах. На нашей платформе есть интерактивная карта с обозначением запретных и ограниченных зон.",
        nameKz: "Ұшулар арнайы бөлінген аймақтарда рұқсат етілген. Біздің платформада тыйым салынған және шектеулі аймақтарды көрсететін интерактивті карта бар.",
        nameEn: 'Flights are allowed in designated areas. Our platform has an interactive map showing prohibited and restricted zones.',
    },
    'Какие документы нужны для регистрации?': {
        nameRu: "Какие документы нужны для регистрации?",
        nameKz: "Тіркеу үшін қандай құжаттар қажет?",
        nameEn: 'What documents are required for registration?',
    },
    'Необходимы документы, удостоверяющие личность (ИИН/БИН), данные о модели и серийном номере дрона, а также документы на право собственности.': {
        nameRu: "Необходимы документы, удостоверяющие личность (ИИН/БИН), данные о модели и серийном номере дрона, а также документы на право собственности.",
        nameKz: "Жеке басын куәландыратын құжаттар (ЖСН/БСН), дронның моделі мен сериялық нөмірі туралы мәліметтер, сондай-ақ меншік құқығы туралы құжаттар қажет.",
        nameEn: 'Identity documents (IIN/BIN), drone model and serial number details, and ownership documents are required.',
    },
    'Можно ли использовать дрон для коммерческих целей?': {
        nameRu: "Можно ли использовать дрон для коммерческих целей?",
        nameKz: "Дронды коммерциялық мақсатта пайдалануға бола ма?",
        nameEn: 'Can a drone be used for commercial purposes?',
    },
    'Да, платформа поддерживает регистрацию дронов как для коммерческих, так и для частных целей. Для коммерческого использования могут потребоваться дополнительные разрешения.': {
        nameRu: "Да, платформа поддерживает регистрацию дронов как для коммерческих, так и для частных целей. Для коммерческого использования могут потребоваться дополнительные разрешения.",
        nameKz: "Иә, платформа дрондарды коммерциялық және жеке мақсаттарға тіркеуді қолдайды. Коммерциялық пайдалану үшін қосымша рұқсаттар қажет болуы мүмкін.",
        nameEn: 'Yes, the platform supports drone registration for both commercial and private purposes. Additional permits may be required for commercial use.',
    },
    'Как подать заявку на полет?': {
        nameRu: "Как подать заявку на полет?",
        nameKz: "Ұшу өтінішін қалай беруге болады?",
        nameEn: 'How do I submit a flight application?',
    },
    'После регистрации дрона вы можете подать заявку на полет через нашу платформу, указав планируемый маршрут и время полета на интерактивной карте.': {
        nameRu: "После регистрации дрона вы можете подать заявку на полет через нашу платформу, указав планируемый маршрут и время полета на интерактивной карте.",
        nameKz: "Дронды тіркегеннен кейін сіз біздің платформа арқылы интерактивті картада жоспарланған маршрут пен ұшу уақытын көрсете отырып, ұшу өтінішін бере аласыз.",
        nameEn: 'After registering a drone, you can submit a flight application through our platform by specifying the planned route and flight time on the interactive map.',
    },
    'Часто задаваемые вопросы': {
        nameRu: "Часто задаваемые вопросы",
        nameKz: "Жиі қойылатын сұрақтар",
        nameEn: 'Frequently asked questions',
    },
    'Ответы на самые популярные вопросы о регистрации и использовании дронов': {
        nameRu: "Ответы на самые популярные вопросы о регистрации и использовании дронов",
        nameKz: "Дрондарды тіркеу және пайдалану туралы ең танымал сұрақтарға жауаптар",
        nameEn: 'Answers to the most common questions about drone registration and use',
    },
    'Узнать больше →': {
        nameRu: "Узнать больше →",
        nameKz: "Көбірек білу →",
        nameEn: 'Learn more →',
    },

    'Новости и статьи': {
        nameRu: "Новости и статьи",
        nameKz: "Жаңалықтар және мақалалар",
        nameEn: 'News and articles',
    },
    'Будьте в курсе последних событий в мире дронов': {
        nameRu: "Будьте в курсе последних событий в мире дронов",
        nameKz: "Дрондар әлеміндегі соңғы оқиғалардан хабардар болыңыз",
        nameEn: 'Stay up to date with the latest events in the world of drones',
    },
    'Все новости': {
        nameRu: "Все новости",
        nameKz: "Барлық жаңалықтар",
        nameEn: 'All news',
    },
    'Не удалось загрузить новости': {
        nameRu: "Не удалось загрузить новости",
        nameKz: "Жаңалықтарды жүктеу мүмкін болмады",
        nameEn: 'Failed to load news',
    },
    'Новости пока отсутствуют': {
        nameRu: "Новости пока отсутствуют",
        nameKz: "Жаңалықтар әлі жоқ",
        nameEn: 'No news yet',
    },
    'Читать далее →': {
        nameRu: "Читать далее →",
        nameKz: "Одан әрі оқу →",
        nameEn: 'Read more →',
    },
    'Галерея дронов': {
        nameRu: "Галерея дронов",
        nameKz: "Дрондар галереясы",
        nameEn: 'Drone gallery',
    },
    'Познакомьтесь с разнообразием беспилотных летательных аппаратов': {
        nameRu: "Познакомьтесь с разнообразием беспилотных летательных аппаратов",
        nameKz: "Пилотсыз ұшу аппараттарының әртүрлілігімен танысыңыз",
        nameEn: 'Explore the variety of unmanned aircraft',
    },
    'Профессиональная аэросъемка': {
        nameRu: "Профессиональная аэросъемка",
        nameKz: "Кәсіби аэрофотосурет",
        nameEn: 'Professional aerial photography',
    },
    '3D моделирование территорий': {
        nameRu: "3D моделирование территорий",
        nameKz: "Аймақтарды 3D модельдеу",
        nameEn: '3D terrain modeling',
    },
    'Инспекция и мониторинг': {
        nameRu: "Инспекция и мониторинг",
        nameKz: "Тексеру және мониторинг",
        nameEn: 'Inspection and monitoring',
    },
    'Точное земледелие': {
        nameRu: "Точное земледелие",
        nameKz: "Дәл ауыл шаруашылығы",
        nameEn: 'Precision agriculture',
    },
    'Возможности применения': {
        nameRu: "Возможности применения",
        nameKz: "Қолдану мүмкіндіктері",
        nameEn: 'Application areas',
    },
    'Реальные примеры использования дронов в различных отраслях': {
        nameRu: "Реальные примеры использования дронов в различных отраслях",
        nameKz: "Әртүрлі салаларда дрондарды пайдаланудың нақты мысалдары",
        nameEn: 'Real examples of drone use across different industries',
    },
    'Инспекция инфраструктуры': {
        nameRu: "Инспекция инфраструктуры",
        nameKz: "Инфрақұрылымды тексеру",
        nameEn: 'Infrastructure inspection',
    },
    'Автоматизированный контроль состояния объектов с помощью дронов': {
        nameRu: "Автоматизированный контроль состояния объектов с помощью дронов",
        nameKz: "Дрондар арқылы объектілердің күйін автоматтандырылған бақылау",
        nameEn: 'Automated condition monitoring of facilities using drones',
    },
    'Точность': {
        nameRu: "Точность",
        nameKz: "Дәлдік",
        nameEn: 'Accuracy',
    },
    'Разрешение': {
        nameRu: "Разрешение",
        nameKz: "Ажыратымдылық",
        nameEn: 'Resolution',
    },
    'Скорость': {
        nameRu: "Скорость",
        nameKz: "Жылдамдық",
        nameEn: 'Speed',
    },
    'Экономия': {
        nameRu: "Экономия",
        nameKz: "Үнемдеу",
        nameEn: 'Savings',
    },
    'Мониторинг урожая и точное внесение удобрений': {
        nameRu: "Мониторинг урожая и точное внесение удобрений",
        nameKz: "Астың мониторингі және тыңайтқыштарды дәл енгізу",
        nameEn: 'Crop monitoring and precise fertilizer application',
    },
    'Урожайность': {
        nameRu: "Урожайность",
        nameKz: "Астың өнімділігі",
        nameEn: 'Yield',
    },
    'Расход воды': {
        nameRu: "Расход воды",
        nameKz: "Су шығыны",
        nameEn: 'Water consumption',
    },
    'Не удалось загрузить погоду': {
        nameRu: "Не удалось загрузить погоду",
        nameKz: "Ауа райын жүктеу мүмкін болмады",
        nameEn: 'Failed to load weather',
    },
    'Загрузка…': {
        nameRu: "Загрузка…",
        nameKz: "Жүктелуде…",
        nameEn: 'Loading…',
    },
    'до': {
        nameRu: "до",
        nameKz: "дейін",
        nameEn: 'to',
    },
    'Картография': {
        nameRu: "Картография",
        nameKz: "Картография",
        nameEn: 'Cartography',
    },
    'Промышленные дроны': {
        nameRu: "Промышленные дроны",
        nameKz: "Өнеркәсіптік дрондар",
        nameEn: 'Industrial drones',
    },
    'Картографирование местности': {
        nameRu: "Картографирование местности",
        nameKz: "Жер бедерін картографиялау",
        nameEn: 'Terrain mapping',
    },
    'Создание высокоточных 3D карт и моделей территорий': {
        nameRu: "Создание высокоточных 3D карт и моделей территорий",
        nameKz: "Аймақтардың жоғары дәлдіктегі 3D карталары мен модельдерін жасау",
        nameEn: 'Creating high-precision 3D maps and terrain models',
    },
    '2см/пиксель': {
        nameRu: "2см/пиксель",
        nameKz: "2см/пиксель",
        nameEn: '2 cm/pixel',
    },
    '200га/день': {
        nameRu: "200га/день",
        nameKz: "200га/күн",
        nameEn: '200 ha/day',
    },
    '1 сезон': {
        nameRu: "1 сезон",
        nameKz: "1 маусым",
        nameEn: '1 season',
    },
    'Назад на главную': {
        nameRu: "Назад на главную",
        nameKz: "Басты бетке оралу",
        nameEn: 'Back to home',
    },
    'Новости': {
        nameRu: "Новости",
        nameKz: "Жаңалықтар",
        nameEn: 'News',
    },
    'Статья не найдена': {
        nameRu: "Статья не найдена",
        nameKz: "Мақала табылмады",
        nameEn: 'Article not found',
    },
    'Нет других новостей': {
        nameRu: "Нет других новостей",
        nameKz: "Басқа жаңалықтар жоқ",
        nameEn: 'No other news',
    },
    'Страница не найдена': {
        nameRu: "Страница не найдена",
        nameKz: "Бет табылмады",
        nameEn: 'Page not found',
    },
    'Данная страница отсутствует или требуется доступ для её просмотра.': {
        nameRu: "Данная страница отсутствует или требуется доступ для её просмотра.",
        nameKz: "Бұл бет жоқ немесе оны көру үшін қол жеткізу қажет.",
        nameEn: 'This page does not exist or access is required to view it.',
    },
    'Если вы считаете, что это ошибка, обратитесь в службу поддержки.': {
        nameRu: "Если вы считаете, что это ошибка, обратитесь в службу поддержки.",
        nameKz: "Егер бұл қате деп ойласаңыз, қолдау қызметіне хабарласыңыз.",
        nameEn: 'If you believe this is an error, contact support.',
    },
    'Законодательство РК': {
        nameRu: "Законодательство РК",
        nameKz: "ҚР заңнамасы",
        nameEn: 'Legislation of the Republic of Kazakhstan',
    },
    'Основные нормативные акты и правила использования БПЛА': {
        nameRu: "Основные нормативные акты и правила использования БПЛА",
        nameKz: "БАҚ пайдаланудың негізгі нормативтік актілері мен ережелері",
        nameEn: 'Key regulations and rules for UAV use',
    },
    'В Республике Казахстан использование дронов регулируется Воздушным кодексом РК и специальными правилами регистрации беспилотных летательных аппаратов.': {
        nameRu: "В Республике Казахстан использование дронов регулируется Воздушным кодексом РК и специальными правилами регистрации беспилотных летательных аппаратов.",
        nameKz: "Қазақстан Республикасында дрондарды пайдалану ҚР Әуе кодексі және пилотсыз ұшу аппараттарын тіркеудің арнайы ережелерімен реттеледі.",
        nameEn: 'In the Republic of Kazakhstan, drone use is regulated by the Air Code of the Republic of Kazakhstan and special rules for registering unmanned aircraft.',
    },
    'Обязательная регистрация дронов весом более 250 грамм': {
        nameRu: "Обязательная регистрация дронов весом более 250 грамм",
        nameKz: "250 грамнан астам салмағы бар дрондарды міндетті тіркеу",
        nameEn: 'Mandatory registration of drones weighing more than 250 grams',
    },
    'Получение разрешения на полёты в контролируемом воздушном пространстве': {
        nameRu: "Получение разрешения на полёты в контролируемом воздушном пространстве",
        nameKz: "Басқарылатын ауа кеңістігінде ұшуға рұқсат алу",
        nameEn: 'Obtaining permission for flights in controlled airspace',
    },
    'Соблюдение ограничений по высоте полёта (до 120 метров)': {
        nameRu: "Соблюдение ограничений по высоте полёта (до 120 метров)",
        nameKz: "Ұшу биіктігі бойынша шектеулерді сақтау (120 метрге дейін)",
        nameEn: 'Compliance with flight altitude limits (up to 120 meters)',
    },
    'Запрет на полёты над массовыми скоплениями людей': {
        nameRu: "Запрет на полёты над массовыми скоплениями людей",
        nameKz: "Адамдардың көпшілік жиналуының үстінен ұшуға тыйым",
        nameEn: 'Prohibition on flights over large gatherings of people',
    },
    'Правила безопасного использования дронов': {
        nameRu: "Правила безопасного использования дронов",
        nameKz: "Дрондарды қауіпсіз пайдалану ережелері",
        nameEn: 'Rules for safe drone use',
    },
    'Безопасность полётов - главный приоритет при использовании беспилотных летательных аппаратов.': {
        nameRu: "Безопасность полётов - главный приоритет при использовании беспилотных летательных аппаратов.",
        nameKz: "Ұшу қауіпсіздігі - пилотсыз ұшу аппараттарын пайдалану кезіндегі басты басымдық.",
        nameEn: 'Flight safety is the top priority when using unmanned aircraft.',
    },
    'Проверка технического состояния перед каждым полётом': {
        nameRu: "Проверка технического состояния перед каждым полётом",
        nameKz: "Әр ұшу алдында техникалық күйін тексеру",
        nameEn: 'Checking technical condition before each flight',
    },
    'Полёты только в хороших погодных условиях': {
        nameRu: "Полёты только в хороших погодных условиях",
        nameKz: "Тек жақсы ауа райы жағдайында ұшу",
        nameEn: 'Flights only in good weather conditions',
    },
    'Соблюдение дистанции от аэропортов (не менее 5 км)': {
        nameRu: "Соблюдение дистанции от аэропортов (не менее 5 км)",
        nameKz: "Әуежайлардан қашықтықты сақтау (кемінде 5 км)",
        nameEn: 'Maintaining distance from airports (at least 5 km)',
    },
    'Наличие страхования гражданской ответственности': {
        nameRu: "Наличие страхования гражданской ответственности",
        nameKz: "Азаматтық жауапкершілікті сақтандырудың болуы",
        nameEn: 'Availability of civil liability insurance',
    },
    'Процесс регистрации беспилотных летательных аппаратов': {
        nameRu: "Процесс регистрации беспилотных летательных аппаратов",
        nameKz: "Пилотсыз ұшу аппараттарын тіркеу процесі",
        nameEn: 'Unmanned aircraft registration process',
    },
    'Регистрация дронов - обязательная процедура для легального использования БПЛА в Казахстане.': {
        nameRu: "Регистрация дронов - обязательная процедура для легального использования БПЛА в Казахстане.",
        nameKz: "Дрондарды тіркеу - Қазақстанда БАҚ-ты заңды пайдалану үшін міндетті процедура.",
        nameEn: 'Drone registration is a mandatory procedure for legal UAV use in Kazakhstan.',
    },
    'Подача заявки через онлайн-платформу': {
        nameRu: "Подача заявки через онлайн-платформу",
        nameKz: "Онлайн-платформа арқылы өтініш беру",
        nameEn: 'Submitting an application through the online platform',
    },
    'Предоставление технических характеристик дрона': {
        nameRu: "Предоставление технических характеристик дрона",
        nameKz: "Дронның техникалық сипаттамаларын ұсыну",
        nameEn: 'Providing drone technical specifications',
    },
    'Получение регистрационного номера': {
        nameRu: "Получение регистрационного номера",
        nameKz: "Тіркеу нөмірін алу",
        nameEn: 'Receiving a registration number',
    },
    'Нанесение номера на корпус БПЛА': {
        nameRu: "Нанесение номера на корпус БПЛА",
        nameKz: "БАҚ корпусына нөмірді салу",
        nameEn: 'Applying the number to the UAV body',
    },
    'Полезные материалы': {
        nameRu: "Полезные материалы",
        nameKz: "Пайдалы материалдар",
        nameEn: 'Useful materials',
    },
    'Дополнительная информация и ресурсы': {
        nameRu: "Дополнительная информация и ресурсы",
        nameKz: "Қосымша ақпарат және ресурстар",
        nameEn: 'Additional information and resources',
    },
    'Образовательные материалы и руководства для пилотов дронов.': {
        nameRu: "Образовательные материалы и руководства для пилотов дронов.",
        nameKz: "Дрон пилоттары үшін білім беру материалдары мен нұсқаулықтары.",
        nameEn: 'Educational materials and guides for drone pilots.',
    },
    'Руководство для начинающих пилотов': {
        nameRu: "Руководство для начинающих пилотов",
        nameKz: "Бастапқы пилоттарға арналған нұсқаулық",
        nameEn: 'Guide for beginner pilots',
    },
    'Инструкции по техническому обслуживанию': {
        nameRu: "Инструкции по техническому обслуживанию",
        nameKz: "Техникалық қызмет көрсету бойынша нұсқаулықтар",
        nameEn: 'Maintenance instructions',
    },
    'Карты запретных зон для полётов': {
        nameRu: "Карты запретных зон для полётов",
        nameKz: "Ұшуға тыйым салынған аймақтардың карталары",
        nameEn: 'Maps of prohibited flight zones',
    },
    'Контакты регулирующих органов': {
        nameRu: "Контакты регулирующих органов",
        nameKz: "Реттеуші органдардың байланыстары",
        nameEn: 'Regulatory authority contacts',
    },
    'Нужно ли регистрировать дрон весом менее 250 грамм?': {
        nameRu: "Нужно ли регистрировать дрон весом менее 250 грамм?",
        nameKz: "250 грамнан аз салмағы бар дронды тіркеу керек пе?",
        nameEn: 'Does a drone weighing less than 250 grams need to be registered?',
    },
    'Нет, дроны весом менее 250 грамм не подлежат обязательной регистрации в Казахстане. Однако рекомендуется соблюдать общие правила безопасности полётов.': {
        nameRu: "Нет, дроны весом менее 250 грамм не подлежат обязательной регистрации в Казахстане. Однако рекомендуется соблюдать общие правила безопасности полётов.",
        nameKz: "Жоқ, 250 грамнан аз салмағы бар дрондар Қазақстанда міндетті тіркеуден өтуге тиіс емес. Алайда, ұшу қауіпсіздігінің жалпы ережелерін сақтау ұсынылады.",
        nameEn: 'No, drones weighing less than 250 grams are not subject to mandatory registration in Kazakhstan. However, it is recommended to follow general flight safety rules.',
    },
    'Где нельзя летать на дроне?': {
        nameRu: "Где нельзя летать на дроне?",
        nameKz: "Дронмен қайда ұшуға болмайды?",
        nameEn: 'Where is it prohibited to fly a drone?',
    },
    'Запрещены полёты над аэропортами (в радиусе 5 км), военными объектами, массовыми мероприятиями, государственными учреждениями и критической инфраструктурой без специального разрешения.': {
        nameRu: "Запрещены полёты над аэропортами (в радиусе 5 км), военными объектами, массовыми мероприятиями, государственными учреждениями и критической инфраструктурой без специального разрешения.",
        nameKz: "Арнайы рұқсатсыз әуежайлардың (5 км радиусында), әскери объектілердің, көпшілік іс-шаралардың, мемлекеттік мекемелердің және сыни инфрақұрылымның үстінен ұшуға тыйым салынған.",
        nameEn: 'Flights over airports (within a 5 km radius), military facilities, mass events, government institutions, and critical infrastructure are prohibited without special permission.',
    },
    'Какая максимальная высота полёта?': {
        nameRu: "Какая максимальная высота полёта?",
        nameKz: "Ұшу максималды биіктігі қандай?",
        nameEn: 'What is the maximum flight altitude?',
    },
    'Максимальная разрешённая высота полёта для любительских дронов составляет 120 метров над уровнем земли. Для коммерческих полётов на большей высоте требуется специальное разрешение.': {
        nameRu: "Максимальная разрешённая высота полёта для любительских дронов составляет 120 метров над уровнем земли. Для коммерческих полётов на большей высоте требуется специальное разрешение.",
        nameKz: "Любительлік дрондар үшін рұқсат етілген максималды ұшу биіктігі жер деңгейінен 120 метр. Жоғары биіктікте коммерциялық ұшулар үшін арнайы рұқсат қажет.",
        nameEn: 'The maximum permitted flight altitude for recreational drones is 120 meters above ground level. Commercial flights at higher altitudes require special permission.',
    },
    'Нужна ли лицензия пилота дрона?': {
        nameRu: "Нужна ли лицензия пилота дрона?",
        nameKz: "Дрон пилотының лицензиясы қажет пе?",
        nameEn: 'Is a drone pilot license required?',
    },
    'Для любительского использования лицензия не требуется. Для коммерческого использования дронов весом более 5 кг необходимо получение свидетельства пилота БПЛА.': {
        nameRu: "Для любительского использования лицензия не требуется. Для коммерческого использования дронов весом более 5 кг необходимо получение свидетельства пилота БПЛА.",
        nameKz: "Любительлік пайдалану үшін лицензия қажет емес. 5 кг-нан астам салмағы бар дрондарды коммерциялық пайдалану үшін БАҚ пилотының куәлігін алу қажет.",
        nameEn: 'A license is not required for recreational use. For commercial use of drones weighing more than 5 kg, a UAV pilot certificate is required.',
    },
    'Обязательно ли страхование?': {
        nameRu: "Обязательно ли страхование?",
        nameKz: "Сақтандыру міндетті ме?",
        nameEn: 'Is insurance mandatory?',
    },
    'Страхование гражданской ответственности обязательно для коммерческого использования дронов. Для любительского использования оно рекомендуется, но не обязательно.': {
        nameRu: "Страхование гражданской ответственности обязательно для коммерческого использования дронов. Для любительского использования оно рекомендуется, но не обязательно.",
        nameKz: "Азаматтық жауапкершілікті сақтандыру дрондарды коммерциялық пайдалану үшін міндетті. Любительлік пайдалану үшін ол ұсынылады, бірақ міндетті емес.",
        nameEn: 'Civil liability insurance is mandatory for commercial drone use. For recreational use, it is recommended but not mandatory.',
    },
    'Назад к новостям': {
        nameRu: "Назад к новостям",
        nameKz: "Жаңалықтарға оралу",
        nameEn: 'Back to news',
    },
    'Последние новости': {
        nameRu: "Последние новости",
        nameKz: "Соңғы жаңалықтар",
        nameEn: 'Latest news',
    },
    'Информация о дронах': {
        nameRu: "Информация о дронах",
        nameKz: "Дрондар туралы ақпарат",
        nameEn: 'Drone information',
    },
    'Всё что нужно знать о беспилотных летательных аппаратах и законодательстве Казахстана': {
        nameRu: "Всё что нужно знать о беспилотных летательных аппаратах и законодательстве Казахстана",
        nameKz: "Пилотсыз ұшу аппараттары және Қазақстан заңнамасы туралы білу керек нәрселер",
        nameEn: 'Everything you need to know about unmanned aircraft and Kazakhstan legislation',
    },

    'Сельское хозяйство': {
        nameRu: "Сельское хозяйство",
        nameKz: "Ауыл шаруашылығы",
        nameEn: 'Agriculture',
    },
    'Ошибка смены роли:': {
        nameRu: "Ошибка смены роли:",
        nameKz: "Рөлді өзгерту қатесі:",
        nameEn: 'Role change error:',
    },
    'Интерактивная карта полетных зон': {
        nameRu: "Интерактивная карта полетных зон",
        nameKz: "Ұшу аймақтарының интерактивті картасы",
        nameEn: 'Interactive flight zone map',
    },
    'Просматривайте актуальные зоны и планируйте безопасные маршруты': {
        nameRu: "Просматривайте актуальные зоны и планируйте безопасные маршруты",
        nameKz: "Актуалды аймақтарды қараңыз және қауіпсіз маршруттарды жоспарлаңыз",
        nameEn: 'View current zones and plan safe routes',
    },
    'Доступные зоны': {
        nameRu: "Доступные зоны",
        nameKz: "Қолжетімді аймақтар",
        nameEn: 'Available zones',
    },
    'Все зоны и ограничения обновляются и отображаются в удобном виде.': {
        nameRu: "Все зоны и ограничения обновляются и отображаются в удобном виде.",
        nameKz: "Барлық аймақтар мен шектеулер жаңартылып, ыңғайлы түрде көрсетіледі.",
        nameEn: 'All zones and restrictions are updated and displayed in a convenient format.',
    },
    'Планирование маршрута': {
        nameRu: "Планирование маршрута",
        nameKz: "Маршрутты жоспарлау",
        nameEn: 'Route planning',
    },
    'Простой интерфейс для построения маршрута и проверки пересечений.': {
        nameRu: "Простой интерфейс для построения маршрута и проверки пересечений.",
        nameKz: "Маршрут құру және қиылысуларды тексеру үшін қарапайым интерфейс.",
        nameEn: 'A simple interface for building routes and checking intersections.',
    },
    'Проверка перед полетом': {
        nameRu: "Проверка перед полетом",
        nameKz: "Ұшуға дейін тексеру",
        nameEn: 'Pre-flight check',
    },
    'Предупреждения по рискам и зонам ограничений перед запуском.': {
        nameRu: "Предупреждения по рискам и зонам ограничений перед запуском.",
        nameKz: "Іске қоспас бұрын тәуекелдер мен шектеу аймақтары туралы ескертулер.",
        nameEn: 'Risk and restriction zone warnings before launch.',
    },
    'Открыть карту': {
        nameRu: "Открыть карту",
        nameKz: "Картаны ашу",
        nameEn: 'Open map',
    },
    'Интерактивная карта зон': {
        nameRu: "Интерактивная карта зон",
        nameKz: "Аймақтардың интерактивті картасы",
        nameEn: 'Interactive zone map',
    },

    'Погода для полётов': {
        nameRu: "Погода для полётов",
        nameKz: "Ұшуға арналған ауа райы",
        nameEn: 'Flight weather',
    },
    'Прогноз на 6 дней: температура и ветер для безопасного планирования полётов. Текущая карта ветров в реальном времени.': {
        nameRu: "Прогноз на 6 дней: температура и ветер для безопасного планирования полётов. Текущая карта ветров в реальном времени.",
        nameKz: "6 күнге болжам: қауіпсіз ұшу жоспарлау үшін температура және жел. Нақты уақыттағы жел картасы.",
        nameEn: '6-day forecast: temperature and wind for safe flight planning. Current real-time wind map.',
    },
    'Заявка на полет отклонена': {
        nameRu: "Заявка на полет отклонена",
        nameKz: "Ұшуға арналған өтініш қабылданбады",
        nameEn: 'Flight application rejected',
    },
    'Ваша заявка на полет': {
        nameRu: "Ваша заявка на полет",
        nameKz: "Сіздің ұшуға арналған өтінішіңіз",
        nameEn: 'Your flight application',
    },
    'была отклонена.': {
        nameRu: "была отклонена.",
        nameKz: "қабылданбады.",
        nameEn: 'was rejected.',
    },
    'Заявка на полет согласована': {
        nameRu: "Заявка на полет согласована",
        nameKz: "Ұшуға арналған өтініш мақұлданды",
        nameEn: 'Flight application approved',
    },
    'Заявка на полет одобрена': {
        nameRu: "Заявка на полет одобрена",
        nameKz: "Ұшуға арналған өтініш мақұлданды",
        nameEn: 'Flight application approved',
    },
    'Заявка на полет на рассмотрении': {
        nameRu: "Заявка на полет на рассмотрении",
        nameKz: "Ұшуға арналған өтініш қаралуда",
        nameEn: 'Flight application under review',
    },
    'была согласована.': {
        nameRu: "была согласована.",
        nameKz: "мақұлданды.",
        nameEn: 'was approved.',
    },
    'Сводная': {
        nameRu: "Сводная",
        nameKz: "Жиынтық",
        nameEn: 'Summary',
    },
    'Заявки': {
        nameRu: "Заявки",
        nameKz: "Өтініштер",
        nameEn: 'Applications',
    },
    'Данные': {
        nameRu: "Данные",
        nameKz: "Деректер",
        nameEn: 'Data',
    },
    'Загрузка секторов': {
        nameRu: "Загрузка секторов",
        nameKz: "Секторларды жүктеу",
        nameEn: 'Loading sectors',
    },
    'Справочники': {
        nameRu: "Справочники",
        nameKz: "Анықтамалықтар",
        nameEn: 'Directories',
    },
    'Логи': {
        nameRu: "Логи",
        nameKz: "Журналдар",
        nameEn: 'Logs',
    },
    'Список пользователей': {
        nameRu: "Список пользователей",
        nameKz: "Пайдаланушылар тізімі",
        nameEn: 'User list',
    },
    'Роли и доступы': {
        nameRu: "Роли и доступы",
        nameKz: "Рөлдер мен қолжетімділік",
        nameEn: 'Roles and access',
    },
    'Редактор карты': {
        nameRu: "Редактор карты",
        nameKz: "Карта редакторы",
        nameEn: 'Map editor',
    },
    'У вас нет прав для просмотра этого раздела.': {
        nameRu: "У вас нет прав для просмотра этого раздела.",
        nameKz: "Сізде бұл бөлімді көруге құқық жоқ.",
        nameEn: 'You do not have permission to view this section.',
    },
    'Проверка прав доступа...': {
        nameRu: "Проверка прав доступа...",
        nameKz: "Қолжетімділік құқықтарын тексеру...",
        nameEn: 'Checking access rights...',
    },
    'Нет доступа к разделу управления секторами': {
        nameRu: "Нет доступа к разделу управления секторами",
        nameKz: "Секторларды басқару бөліміне қолжетімділік жоқ",
        nameEn: 'No access to the sector management section',
    },
    'Данный раздел доступен только пользователям с ролями root и admin.': {
        nameRu: "Данный раздел доступен только пользователям с ролями root и admin.",
        nameKz: "Бұл бөлім тек root және admin рөлдері бар пайдаланушыларға қолжетімді.",
        nameEn: 'This section is available only to users with root and admin roles.',
    },
    'Управление данными': {
        nameRu: "Управление данными",
        nameKz: "Деректерді басқару",
        nameEn: 'Data management',
    },
    'Все данные о секторах управляются через редактор карты': {
        nameRu: "Все данные о секторах управляются через редактор карты",
        nameKz: "Секторлар туралы барлық деректер карта редакторы арқылы басқарылады",
        nameEn: 'All sector data is managed through the map editor',
    },
    'Для редактирования секторов перейдите в раздел "Редактор карты" в боковом меню.': {
        nameRu: "Для редактирования секторов перейдите в раздел \"Редактор карты\" в боковом меню.",
        nameKz: "Секторларды өңдеу үшін бүйірлік мәзірдегі \"Карта редакторы\" бөліміне өтіңіз.",
        nameEn: 'To edit sectors, go to the "Map editor" section in the side menu.',
    },
    'Импорт и экспорт секторов': {
        nameRu: "Импорт и экспорт секторов",
        nameKz: "Секторларды импорттау және экспорттау",
        nameEn: 'Import and export sectors',
    },
    'Загрузите новые данные о секторах или выгрузите текущие': {
        nameRu: "Загрузите новые данные о секторах или выгрузите текущие",
        nameKz: "Секторлар туралы жаңа деректерді жүктеңіз немесе ағымдағыларды жүктеңіз",
        nameEn: 'Upload new sector data or export current data',
    },
    'Всего секторов в базе': {
        nameRu: "Всего секторов в базе",
        nameKz: "Базадағы барлық секторлар",
        nameEn: 'Total sectors in database',
    },
    'Импорт секторов': {
        nameRu: "Импорт секторов",
        nameKz: "Секторларды импорттау",
        nameEn: 'Import sectors',
    },
    'Файл не выбран': {
        nameRu: "Файл не выбран",
        nameKz: "Файл таңдалмаған",
        nameEn: 'No file selected',
    },

    'Выбрать файл': {
        nameRu: "Выбрать файл",
        nameKz: "Файлды таңдау",
        nameEn: 'Select file',
    },
    'Поддерживаются файлы GeoJSON. При импорте все существующие секторы будут заменены.': {
        nameRu: "Поддерживаются файлы GeoJSON. При импорте все существующие секторы будут заменены.",
        nameKz: "GeoJSON файлдары қолдайды. Импорттау кезінде барлық бар секторлар ауыстырылады.",
        nameEn: 'GeoJSON files are supported. During import, all existing sectors will be replaced.',
    },
    'Экспорт секторов': {
        nameRu: "Экспорт секторов",
        nameKz: "Секторларды экспорттау",
        nameEn: 'Export sectors',
    },
    'Скачать все секторы (GeoJSON)': {
        nameRu: "Скачать все секторы (GeoJSON)",
        nameKz: "Барлық секторларды жүктеу (GeoJSON)",
        nameEn: 'Download all sectors (GeoJSON)',
    },
    'Выгрузить все секторы в формате GeoJSON для резервного копирования или редактирования': {
        nameRu: "Выгрузить все секторы в формате GeoJSON для резервного копирования или редактирования",
        nameKz: "Резервтік көшіру немесе өңдеу үшін барлық секторларды GeoJSON форматында жүктеу",
        nameEn: 'Export all sectors in GeoJSON format for backup or editing',
    },
    'Опасная зона': {
        nameRu: "Опасная зона",
        nameKz: "Қауіпті аймақ",
        nameEn: 'Danger zone',
    },
    'Удалить все секторы': {
        nameRu: "Удалить все секторы",
        nameKz: "Барлық секторларды жою",
        nameEn: 'Delete all sectors',
    },
    'Удаление всех данных доступно только пользователю с ролью root.': {
        nameRu: "Удаление всех данных доступно только пользователю с ролью root.",
        nameKz: "Барлық деректерді жою тек root рөлі бар пайдаланушыға қолжетімді.",
        nameEn: 'Deleting all data is available only to users with the root role.',
    },
    'Подтверждение удаления всех секторов': {
        nameRu: "Подтверждение удаления всех секторов",
        nameKz: "Барлық секторларды жоюды растау",
        nameEn: 'Confirm deletion of all sectors',
    },
    'Это действие необратимо!': {
        nameRu: "Это действие необратимо!",
        nameKz: "Бұл әрекет қайтымсыз!",
        nameEn: 'This action is irreversible!',
    },
    'Введите текст': {
        nameRu: "Введите текст",
        nameKz: "Мәтінді енгізіңіз",
        nameEn: 'Enter text',
    },
    'в поле ниже для подтверждения.': {
        nameRu: "в поле ниже для подтверждения.",
        nameKz: "растау үшін төмендегі өріске.",
        nameEn: 'in the field below to confirm.',
    },
    'Удалить все данные': {
        nameRu: "Удалить все данные",
        nameKz: "Барлық деректерді жою",
        nameEn: 'Delete all data',
    },
    'Только root может импортировать данные о секторах': {
        nameRu: "Только root может импортировать данные о секторах",
        nameKz: "Тек root секторлар туралы деректерді импорттай алады",
        nameEn: 'Only root can import sector data',
    },
    'Поддерживаются только файлы GeoJSON (.geojson, .json)': {
        nameRu: "Поддерживаются только файлы GeoJSON (.geojson, .json)",
        nameKz: "Тек GeoJSON файлдары қолдайды (.geojson, .json)",
        nameEn: 'Only GeoJSON files (.geojson, .json) are supported',
    },
    'Файл должен быть GeoJSON FeatureCollection': {
        nameRu: "Файл должен быть GeoJSON FeatureCollection",
        nameKz: "Файл GeoJSON FeatureCollection болуы керек",
        nameEn: 'The file must be a GeoJSON FeatureCollection',
    },
    'Файл не содержит ни одного объекта': {
        nameRu: "Файл не содержит ни одного объекта",
        nameKz: "Файлда бірде-бір объект жоқ",
        nameEn: 'The file does not contain any features',
    },
    'Некорректная геометрия в одном из объектов': {
        nameRu: "Некорректная геометрия в одном из объектов",
        nameKz: "Объектілердің бірінде дұрыс емес геометрия",
        nameEn: 'Invalid geometry in one of the features',
    },
    'Файл не содержит корректных данных о секторах': {
        nameRu: "Файл не содержит корректных данных о секторах",
        nameKz: "Файлда секторлар туралы дұрыс деректер жоқ",
        nameEn: 'The file does not contain valid sector data',
    },
    'Текущие записи будут обновлены/добавлены на основе загружаемого файла. Продолжить?': {
        nameRu: "Текущие записи будут обновлены/добавлены на основе загружаемого файла. Продолжить?",
        nameKz: "Ағымдағы жазбалар жүктелетін файл негізінде жаңартылады/қосылады. Жалғастыру керек пе?",
        nameEn: 'Current records will be updated/added based on the uploaded file. Continue?',
    },
    'Импортировать': {
        nameRu: "Импортировать",
        nameKz: "Импорттау",
        nameEn: 'Import',
    },
    'Данные о секторах успешно импортированы': {
        nameRu: "Данные о секторах успешно импортированы",
        nameKz: "Секторлар туралы деректер сәтті импортталды",
        nameEn: 'Sector data imported successfully',
    },
    'Ошибка импорта секторов': {
        nameRu: "Ошибка импорта секторов",
        nameKz: "Секторларды импорттау қатесі",
        nameEn: 'Sector import error',
    },
    'Ошибка чтения или формата файла': {
        nameRu: "Ошибка чтения или формата файла",
        nameKz: "Файлды оқу немесе формат қатесі",
        nameEn: 'File reading or format error',
    },
    'Только root может удалять все сектора': {
        nameRu: "Только root может удалять все сектора",
        nameKz: "Тек root барлық секторларды жоя алады",
        nameEn: 'Only root can delete all sectors',
    },
    'Все сектора успешно удалены': {
        nameRu: "Все сектора успешно удалены",
        nameKz: "Барлық секторлар сәтті жойылды",
        nameEn: 'All sectors deleted successfully',
    },
    'Ошибка удаления секторов': {
        nameRu: "Ошибка удаления секторов",
        nameKz: "Секторларды жою қатесі",
        nameEn: 'Error deleting sectors',
    },
    'Не удалось загрузить данные о секторах': {
        nameRu: "Не удалось загрузить данные о секторах",
        nameKz: "Секторлар туралы деректерді жүктеу мүмкін болмады",
        nameEn: 'Failed to load sector data',
    },
    'Файл с секторами успешно сформирован и скачан': {
        nameRu: "Файл с секторами успешно сформирован и скачан",
        nameKz: "Секторлармен файл сәтті құрылды және жүктелді",
        nameEn: 'The sector file has been generated and downloaded successfully',
    },
    'Ошибка экспорта секторов': {
        nameRu: "Ошибка экспорта секторов",
        nameKz: "Секторларды экспорттау қатесі",
        nameEn: 'Sector export error',
    },
    'Районы': {
        nameRu: "Районы",
        nameKz: "Аудандар",
        nameEn: 'Districts',
    },
    'Типы зон': {
        nameRu: "Типы зон",
        nameKz: "Аймақ түрлері",
        nameEn: 'Zone types',
    },
    'Цели полетов': {
        nameRu: "Цели полетов",
        nameKz: "Ұшу мақсаттары",
        nameEn: 'Flight purposes',
    },
    'Статусы секторов': {
        nameRu: "Статусы секторов",
        nameKz: "Секторлардың мәртебелері",
        nameEn: 'Sector statuses',
    },
    'Название (RU)': {
        nameRu: "Название (RU)",
        nameKz: "Атауы (RU)",
        nameEn: 'Name (RU)',
    },
    'Название (KZ)': {
        nameRu: "Название (KZ)",
        nameKz: "Атауы (KZ)",
        nameEn: 'Name (KZ)',
    },
    'Цвет (HEX)': {
        nameRu: "Цвет (HEX)",
        nameKz: "Түс (HEX)",
        nameEn: 'Color (HEX)',
    },
    'Не удалось загрузить справочники': {
        nameRu: "Не удалось загрузить справочники",
        nameKz: "Анықтамалықтарды жүктеу мүмкін болмады",
        nameEn: 'Failed to load directories',
    },
    'У вас нет прав для редактирования': {
        nameRu: "У вас нет прав для редактирования",
        nameKz: "Сізде өңдеу құқығы жоқ",
        nameEn: 'You do not have permission to edit',
    },
    'Данные успешно обновлены': {
        nameRu: "Данные успешно обновлены",
        nameKz: "Деректер сәтті жаңартылды",
        nameEn: 'Data updated successfully',
    },
    'Данные успешно добавлены': {
        nameRu: "Данные успешно добавлены",
        nameKz: "Деректер сәтті қосылды",
        nameEn: 'Data added successfully',
    },
    'Ошибка сохранения:': {
        nameRu: "Ошибка сохранения:",
        nameKz: "Сақтау қатесі:",
        nameEn: 'Save error:',
    },
    'Редактирование:': {
        nameRu: "Редактирование:",
        nameKz: "Өңдеу:",
        nameEn: 'Editing:',
    },
    'Добавление:': {
        nameRu: "Добавление:",
        nameKz: "Қосу:",
        nameEn: 'Adding:',
    },
    'Дата и время': {
        nameRu: "Дата и время",
        nameKz: "Күні мен уақыты",
        nameEn: 'Date and time',
    },
    'Не авторизован': {
        nameRu: "Не авторизован",
        nameKz: "Авторизацияланбаған",
        nameEn: 'Not authorized',
    },

    'Модератор': {
        nameRu: "Модератор",
        nameKz: "Модератор",
        nameEn: 'Moderator',
    },
    'Гость': {
        nameRu: "Гость",
        nameKz: "Қонақ",
        nameEn: 'Guest',
    },
    'Все': {
        nameRu: "Все",
        nameKz: "Барлығы",
        nameEn: 'All',
    },
    'Гости': {
        nameRu: "Гости",
        nameKz: "Қонақтар",
        nameEn: 'Guests',
    },
    'Модераторы': {
        nameRu: "Модераторы",
        nameKz: "Модераторлар",
        nameEn: 'Moderators',
    },
    'Администраторы': {
        nameRu: "Администраторы",
        nameKz: "Әкімшілер",
        nameEn: 'Administrators',
    },
    'Логи действий пользователей': {
        nameRu: "Логи действий пользователей",
        nameKz: "Пайдаланушылар әрекеттерінің журналдары",
        nameEn: 'User activity logs',
    },
    'История действий всех пользователей системы': {
        nameRu: "История действий всех пользователей системы",
        nameKz: "Жүйедегі барлық пайдаланушылардың әрекеттерінің тарихы",
        nameEn: 'Activity history of all system users',
    },
    'Данные обновлены': {
        nameRu: "Данные обновлены",
        nameKz: "Деректер жаңартылды",
        nameEn: 'Data updated',
    },
    'Таблица': {
        nameRu: "Таблица",
        nameKz: "Кесте",
        nameEn: 'Table',
    },
    'Ограничения': {
        nameRu: "Ограничения",
        nameKz: "Шектеулер",
        nameEn: 'Restrictions',
    },
    'Поиск сектора по ID': {
        nameRu: "Поиск сектора по ID",
        nameKz: "ID бойынша секторды іздеу",
        nameEn: 'Search sector by ID',
    },
    'Редактирование границ': {
        nameRu: "Редактирование границ",
        nameKz: "Шекараларды өңдеу",
        nameEn: 'Boundary editing',
    },
    'Перетащите вершины полигона на карте.': {
        nameRu: "Перетащите вершины полигона на карте.",
        nameKz: "Картадағы полигон төбелерін сүйреңіз.",
        nameEn: 'Drag the polygon vertices on the map.',
    },
    'Все изменения применяются только после сохранения.': {
        nameRu: "Все изменения применяются только после сохранения.",
        nameKz: "Барлық өзгерістер тек сақталғаннан кейін қолданылады.",
        nameEn: 'All changes are applied only after saving.',
    },
    'Сохранить границы': {
        nameRu: "Сохранить границы",
        nameKz: "Шекараларды сақтау",
        nameEn: 'Save boundaries',
    },
    'Обновить': {
        nameRu: "Обновить",
        nameKz: "Жаңарту",
        nameEn: 'Refresh',
    },
    'Спутник': {
        nameRu: "Спутник",
        nameKz: "Спутник",
        nameEn: 'Satellite',
    },
    'Улицы': {
        nameRu: "Улицы",
        nameKz: "Көшелер",
        nameEn: 'Streets',
    },
    'Область ограничения': {
        nameRu: "Область ограничения",
        nameKz: "Шектеу аймағы",
        nameEn: 'Restriction area',
    },
    'Ограничение маршрута': {
        nameRu: "Ограничение маршрута",
        nameKz: "Маршрут шектеуі",
        nameEn: 'Route restriction',
    },
    'Добавить полигон': {
        nameRu: "Добавить полигон",
        nameKz: "Полигон қосу",
        nameEn: 'Add polygon',
    },
    'Границы сохранены': {
        nameRu: "Границы сохранены",
        nameKz: "Шекаралар сақталды",
        nameEn: 'Boundaries saved',
    },
    'Ошибка сохранения границ': {
        nameRu: "Ошибка сохранения границ",
        nameKz: "Шекараларды сақтау қатесі",
        nameEn: 'Error saving boundaries',
    },
    'Нарисованный полигон не пересекается ни с одним сектором': {
        nameRu: "Нарисованный полигон не пересекается ни с одним сектором",
        nameKz: "Сызылған полигон ешбір сектормен қиылыспайды",
        nameEn: 'The drawn polygon does not intersect any sector',
    },
    'Не удалось проверить пересечения': {
        nameRu: "Не удалось проверить пересечения",
        nameKz: "Қиылысуларды тексеру мүмкін болмады",
        nameEn: 'Failed to check intersections',
    },
    'Нарисованная линия не пересекается ни с одним сектором': {
        nameRu: "Нарисованная линия не пересекается ни с одним сектором",
        nameKz: "Сызылған сызық ешбір сектормен қиылыспайды",
        nameEn: 'The drawn line does not intersect any sector',
    },
    'Не удалось обработать геометрию полигона': {
        nameRu: "Не удалось обработать геометрию полигона",
        nameKz: "Полигон геометриясын өңдеу мүмкін болмады",
        nameEn: 'Failed to process polygon geometry',
    },
    'Не удалось добавить полигон для редактирования': {
        nameRu: "Не удалось добавить полигон для редактирования",
        nameKz: "Өңдеу үшін полигонды қосу мүмкін болмады",
        nameEn: 'Failed to add polygon for editing',
    },
    'Не удалось загрузить геометрию полигона': {
        nameRu: "Не удалось загрузить геометрию полигона",
        nameKz: "Полигон геометриясын жүктеу мүмкін болмады",
        nameEn: 'Failed to load polygon geometry',
    },
    'Полигон удален. Редактирование отменено.': {
        nameRu: "Полигон удален. Редактирование отменено.",
        nameKz: "Полигон жойылды. Өңдеу тоқтатылды.",
        nameEn: 'Polygon deleted. Editing canceled.',
    },
    'Нет полигона для сохранения': {
        nameRu: "Нет полигона для сохранения",
        nameKz: "Сақтау үшін полигон жоқ",
        nameEn: 'No polygon to save',
    },
    'Временные ограничения удалены': {
        nameRu: "Временные ограничения удалены",
        nameKz: "Уақытша шектеулер жойылды",
        nameEn: 'Temporary restrictions removed',
    },
    'Ограничения обновлены': {
        nameRu: "Ограничения обновлены",
        nameKz: "Шектеулер жаңартылды",
        nameEn: 'Restrictions updated',
    },
    'Сектор успешно обновлен': {
        nameRu: "Сектор успешно обновлен",
        nameKz: "Сектор сәтті жаңартылды",
        nameEn: 'Sector updated successfully',
    },
    'Геометрия полигона отсутствует': {
        nameRu: "Геометрия полигона отсутствует",
        nameKz: "Полигон геометриясы жоқ",
        nameEn: 'Polygon geometry is missing',
    },
    'Сектор успешно создан': {
        nameRu: "Сектор успешно создан",
        nameKz: "Сектор сәтті құрылды",
        nameEn: 'Sector created successfully',
    },

    'Ограничения сняты для': {
        nameRu: "Ограничения сняты для",
        nameKz: "Шектеулер алынып тасталды",
        nameEn: 'Restrictions removed for',
    },
    'секторов': {
        nameRu: "секторов",
        nameKz: "секторлар",
        nameEn: 'sectors',
    },
    'Ограничения установлены для': {
        nameRu: "Ограничения установлены для",
        nameKz: "Шектеулер орнатылды",
        nameEn: 'Restrictions set for',
    },
    'Ошибка при применении изменений:': {
        nameRu: "Ошибка при применении изменений:",
        nameKz: "Өзгерістерді қолдану кезіндегі қате:",
        nameEn: 'Error applying changes:',
    },

    'Ошибка:': {
        nameRu: "Ошибка:",
        nameKz: "Қате:",
        nameEn: 'Error:',
    },

    'IP адрес': {
        nameRu: "IP адрес",
        nameKz: "IP мекенжайы",
        nameEn: 'IP address',
    },
    'Метаданные': {
        nameRu: "Метаданные",
        nameKz: "Метадеректер",
        nameEn: 'Metadata',
    },
    'Всего:': {
        nameRu: "Всего:",
        nameKz: "Барлығы:",
        nameEn: 'Total:',
    },
    'Нет данных': {
        nameRu: "Нет данных",
        nameKz: "Деректер жоқ",
        nameEn: 'No data',
    },
    'Активен': {
        nameRu: "Активен",
        nameKz: "Белсенді",
        nameEn: 'Active',
    },
    'Значение': {
        nameRu: "Значение",
        nameKz: "Мән",
        nameEn: 'Value',
    },
    'Цвет': {
        nameRu: "Цвет",
        nameKz: "Түс",
        nameEn: 'Color',
    },
    'Вы не можете изменить свою собственную роль': {
        nameRu: "Вы не можете изменить свою собственную роль",
        nameKz: "Сіз өз рөліңізді өзгерте алмайсыз",
        nameEn: 'You cannot change your own role',
    },
    'Текущая роль:': {
        nameRu: "Текущая роль:",
        nameKz: "Ағымдағы рөл:",
        nameEn: 'Current role:',
    },
    'Нет доступных ролей для смены.': {
        nameRu: "Нет доступных ролей для смены.",
        nameKz: "Ауыстыруға қолжетімді рөлдер жоқ.",
        nameEn: 'No roles available for change.',
    },
    'Подтверждение смены роли': {
        nameRu: "Подтверждение смены роли",
        nameKz: "Рөлді ауыстыруды растау",
        nameEn: 'Confirm role change',
    },
    'Вы уверены, что хотите изменить роль пользователя': {
        nameRu: "Вы уверены, что хотите изменить роль пользователя",
        nameKz: "Пайдаланушының рөлін өзгертуге сенімдісіз бе",
        nameEn: "Are you sure you want to change the user's role",
    },
    'с': {
        nameRu: "с",
        nameKz: "ден",
        nameEn: 'from',
    },
    'на': {
        nameRu: "на",
        nameKz: "ға",
        nameEn: 'to',
    },
    'Изменить': {
        nameRu: "Изменить",
        nameKz: "Өзгерту",
        nameEn: 'Change',
    },
    'Управление ролями пользователей': {
        nameRu: "Управление ролями пользователей",
        nameKz: "Пайдаланушылар рөлдерін басқару",
        nameEn: 'User role management',
    },
    'Нет пользователей с этой ролью': {
        nameRu: "Нет пользователей с этой ролью",
        nameKz: "Бұл рөлде пайдаланушылар жоқ",
        nameEn: 'No users with this role',
    },

    'Вы уверены, что хотите удалить новость': {
        nameRu: "Вы уверены, что хотите удалить новость",
        nameKz: "Жаңалықты жоюға сенімдісіз бе",
        nameEn: 'Are you sure you want to delete the news item',
    },
    'Новость успешно удалена': {
        nameRu: "Новость успешно удалена",
        nameKz: "Жаңалық сәтті жойылды",
        nameEn: 'News item deleted successfully',
    },
    'Ошибка удаления:': {
        nameRu: "Ошибка удаления:",
        nameKz: "Жою қатесі:",
        nameEn: 'Deletion error:',
    },
    'Новость успешно обновлена': {
        nameRu: "Новость успешно обновлена",
        nameKz: "Жаңалық сәтті жаңартылды",
        nameEn: 'News item updated successfully',
    },
    'Новость успешно добавлена': {
        nameRu: "Новость успешно добавлена",
        nameKz: "Жаңалық сәтті қосылды",
        nameEn: 'News item added successfully',
    },
    'Изображение загружено': {
        nameRu: "Изображение загружено",
        nameKz: "Сурет жүктелді",
        nameEn: 'Image uploaded',
    },
    'Ошибка загрузки изображения': {
        nameRu: "Ошибка загрузки изображения",
        nameKz: "Суретті жүктеу қатесі",
        nameEn: 'Image upload error',
    },
    'Видео загружено': {
        nameRu: "Видео загружено",
        nameKz: "Бейне жүктелді",
        nameEn: 'Video uploaded',
    },
    'Ошибка загрузки видео': {
        nameRu: "Ошибка загрузки видео",
        nameKz: "Бейнені жүктеу қатесі",
        nameEn: 'Video upload error',
    },
    'Фото': {
        nameRu: "Фото",
        nameKz: "Фото",
        nameEn: 'Photo',
    },
    'Видео': {
        nameRu: "Видео",
        nameKz: "Бейне",
        nameEn: 'Video',
    },
    'Заголовок': {
        nameRu: "Заголовок",
        nameKz: "Тақырып",
        nameEn: 'Title',
    },
    'Краткое описание': {
        nameRu: "Краткое описание",
        nameKz: "Қысқаша сипаттама",
        nameEn: 'Short description',
    },
    'Опубликовано': {
        nameRu: "Опубликовано",
        nameKz: "Жарияланды",
        nameEn: 'Published',
    },
    'Дата публикации': {
        nameRu: "Дата публикации",
        nameKz: "Жариялау күні",
        nameEn: 'Publication date',
    },
    'Дата создания': {
        nameRu: "Дата создания",
        nameKz: "Құрылған күні",
        nameEn: 'Creation date',
    },
    'Просмотр': {
        nameRu: "Просмотр",
        nameKz: "Қарау",
        nameEn: 'View',
    },
    'ФИО / Организация': {
        nameRu: "ФИО / Организация",
        nameKz: "Аты-жөні / Ұйым",
        nameEn: 'Full name / Organization',
    },
    'ИИН / БИИН': {
        nameRu: "ИИН / БИИН",
        nameKz: "ЖСН / БСН",
        nameEn: 'IIN / BIIN',
    },

    'Дата регистрации': {
        nameRu: "Дата регистрации",
        nameKz: "Тіркелу күні",
        nameEn: 'Registration date',
    },
    'Смена роли': {
        nameRu: "Смена роли",
        nameKz: "Рөлді ауыстыру",
        nameEn: 'Role change',
    },
    'Ф.И.О.': {
        nameRu: "Ф.И.О.",
        nameKz: "Аты-жөні",
        nameEn: 'Full name',
    },

    'сектора': {
        nameRu: "сектора",
        nameKz: "секторлар",
        nameEn: 'sectors',
    },

    'Высота (м)': {
        nameRu: "Высота (м)",
        nameKz: "Биіктік (м)",
        nameEn: 'Altitude (m)',
    },
    'Комментарий заявителя': {
        nameRu: "Комментарий заявителя",
        nameKz: "Өтініш берушінің түсініктемесі",
        nameEn: 'Applicant comment',
    },
    'Не отработана модератором, п...': {
        nameRu: "Не отработана модератором, п...",
        nameKz: "Модератор тарапынан өңделмеген, п...",
        nameEn: 'Not processed by moderator, p...',
    },
    'Редактировать паспорт': {
        nameRu: "Редактировать паспорт",
        nameKz: "Паспортты өңдеу",
        nameEn: 'Edit passport',
    },
    'Временное ограничение': {
        nameRu: "Временное ограничение",
        nameKz: "Уақытша шектеу",
        nameEn: 'Temporary restriction',
    },
    'Сначала нарисуйте полигон на карте': {
        nameRu: "Сначала нарисуйте полигон на карте",
        nameKz: "Алдымен картада полигон сызыңыз",
        nameEn: 'First draw a polygon on the map',
    },
    'Создание нового сектора': {
        nameRu: "Создание нового сектора",
        nameKz: "Жаңа сектор құру",
        nameEn: 'Create new sector',
    },
    'Редактирование данных сектора': {
        nameRu: "Редактирование данных сектора",
        nameKz: "Сектор деректерін өңдеу",
        nameEn: 'Edit sector data',
    },
    'Нарисуйте полигон на карте, затем заполните данные сектора': {
        nameRu: "Нарисуйте полигон на карте, затем заполните данные сектора",
        nameKz: "Картада полигон сызыңыз, содан кейін сектор деректерін толтырыңыз",
        nameEn: 'Draw a polygon on the map, then fill in the sector data',
    },
    'Основная информация': {
        nameRu: "Основная информация",
        nameKz: "Негізгі ақпарат",
        nameEn: 'Basic information',
    },
    'Выберите район': {
        nameRu: "Выберите район",
        nameKz: "Ауданды таңдаңыз",
        nameEn: 'Select district',
    },
    'Доступность зоны': {
        nameRu: "Доступность зоны",
        nameKz: "Аймақтың қолжетімділігі",
        nameEn: 'Zone availability',
    },
    'Выберите доступность зоны': {
        nameRu: "Выберите доступность зоны",
        nameKz: "Аймақтың қолжетімділігін таңдаңыз",
        nameEn: 'Select zone availability',
    },
    'Требуется спецразрешение': {
        nameRu: "Требуется спецразрешение",
        nameKz: "Арнайы рұқсат қажет",
        nameEn: 'Special permit required',
    },
    'Препятствия': {
        nameRu: "Препятствия",
        nameKz: "Кедергілер",
        nameEn: 'Obstacles',
    },
    'Кол-во зданий': {
        nameRu: "Кол-во зданий",
        nameKz: "Ғимараттар саны",
        nameEn: 'Number of buildings',
    },
    'Макс. высота зданий (м)': {
        nameRu: "Макс. высота зданий (м)",
        nameKz: "Ғимараттардың макс. биіктігі (м)",
        nameEn: 'Max. building height (m)',
    },
    'Макс. высота деревьев (м)': {
        nameRu: "Макс. высота деревьев (м)",
        nameKz: "Ағаштардың макс. биіктігі (м)",
        nameEn: 'Max. tree height (m)',
    },
    'Линии электропередач': {
        nameRu: "Линии электропередач",
        nameKz: "Электр беру желілері",
        nameEn: 'Power lines',
    },
    'Макс. высота ЛЭП (м)': {
        nameRu: "Макс. высота ЛЭП (м)",
        nameKz: "ЭЖБ макс. биіктігі (м)",
        nameEn: 'Max. power line height (m)',
    },
    'Параметры полета': {
        nameRu: "Параметры полета",
        nameKz: "Ұшу параметрлері",
        nameEn: 'Flight parameters',
    },
    'Мин. высота полета (м)': {
        nameRu: "Мин. высота полета (м)",
        nameKz: "Ұшу мин. биіктігі (м)",
        nameEn: 'Min. flight altitude (m)',
    },
    'Макс. высота полета (м)': {
        nameRu: "Макс. высота полета (м)",
        nameKz: "Ұшу макс. биіктігі (м)",
        nameEn: 'Max. flight altitude (m)',
    },
    'Разрешенные дни': {
        nameRu: "Разрешенные дни",
        nameKz: "Рұқсат етілген күндер",
        nameEn: 'Allowed days',
    },
    'Создать сектор': {
        nameRu: "Создать сектор",
        nameKz: "Сектор құру",
        nameEn: 'Create sector',
    },
    'Сохранить изменения': {
        nameRu: "Сохранить изменения",
        nameKz: "Өзгерістерді сақтау",
        nameEn: 'Save changes',
    },
    'Открытая зона': {
        nameRu: "Открытая зона",
        nameKz: "Ашық аймақ",
        nameEn: 'Open zone',
    },
    'Частично доступная': {
        nameRu: "Частично доступная",
        nameKz: "Жартылай қолжетімді",
        nameEn: 'Partially available',
    },
    'Закрытая зона': {
        nameRu: "Закрытая зона",
        nameKz: "Жабық аймақ",
        nameEn: 'Closed zone',
    },
    'Выберите хотя бы один сектор': {
        nameRu: "Выберите хотя бы один сектор",
        nameKz: "Кем дегенде бір секторды таңдаңыз",
        nameEn: 'Select at least one sector',
    },
    'Ошибка валидации формы': {
        nameRu: "Ошибка валидации формы",
        nameKz: "Форманы тексеру қатесі",
        nameEn: 'Form validation error',
    },
    'Среди секторов нет секторов с временными ограничениями': {
        nameRu: "Среди секторов нет секторов с временными ограничениями",
        nameKz: "Секторлар арасында уақытша шектеулері бар секторлар жоқ",
        nameEn: 'There are no sectors with temporary restrictions among the selected sectors',
    },
    'Ошибка при удалении ограничений': {
        nameRu: "Ошибка при удалении ограничений",
        nameKz: "Шектеулерді жою кезіндегі қате",
        nameEn: 'Error removing restrictions',
    },
    'Действие ограничения': {
        nameRu: "Действие ограничения",
        nameKz: "Шектеудің әрекеті",
        nameEn: 'Restriction action',
    },
    'Выберите период': {
        nameRu: "Выберите период",
        nameKz: "Кезеңді таңдаңыз",
        nameEn: 'Select period',
    },
    'Время начала ограничения': {
        nameRu: "Время начала ограничения",
        nameKz: "Шектеудің басталу уақыты",
        nameEn: 'Restriction start time',
    },
    'Время окончания ограничения': {
        nameRu: "Время окончания ограничения",
        nameKz: "Шектеудің аяқталу уақыты",
        nameEn: 'Restriction end time',
    },
    'Выберите ограничение': {
        nameRu: "Выберите ограничение",
        nameKz: "Шектеуді таңдаңыз",
        nameEn: 'Select restriction',
    },
    'Введите комментарий...': {
        nameRu: "Введите комментарий...",
        nameKz: "Түсініктеме енгізіңіз...",
        nameEn: 'Enter comment...',
    },
    'Убрать ограничения': {
        nameRu: "Убрать ограничения",
        nameKz: "Шектеулерді алып тастау",
        nameEn: 'Remove restrictions',
    },
    'Отменить': {
        nameRu: "Отменить",
        nameKz: "Болдырмау",
        nameEn: 'Cancel',
    },
    'Снять все': {
        nameRu: "Снять все",
        nameKz: "Барлығын алып тастау",
        nameEn: 'Clear all',
    },
    'Выбрать все': {
        nameRu: "Выбрать все",
        nameKz: "Барлығын таңдау",
        nameEn: 'Select all',
    },
    'Временное ограничение снято': {
        nameRu: "Временное ограничение снято",
        nameKz: "Уақытша шектеу алынып тасталды",
        nameEn: 'Temporary restriction removed',
    },
    'Не удалось снять ограничение': {
        nameRu: "Не удалось снять ограничение",
        nameKz: "Шектеуді алып тастау мүмкін болмады",
        nameEn: 'Failed to remove restriction',
    },
    'Не удалось снять ограничения': {
        nameRu: "Не удалось снять ограничения",
        nameKz: "Шектеулерді алып тастау мүмкін болмады",
        nameEn: 'Failed to remove restrictions',
    },
    'Показать на карте': {
        nameRu: "Показать на карте",
        nameKz: "Картада көрсету",
        nameEn: 'Show on map',
    },
    'Удалить ограничение': {
        nameRu: "Удалить ограничение",
        nameKz: "Шектеуді жою",
        nameEn: 'Delete restriction',
    },
    'Снять временное ограничение?': {
        nameRu: "Снять временное ограничение?",
        nameKz: "Уақытша шектеуді алып тастау керек пе?",
        nameEn: 'Remove temporary restriction?',
    },
    'Вы уверены, что хотите снять временное ограничение для этого сектора?': {
        nameRu: "Вы уверены, что хотите снять временное ограничение для этого сектора?",
        nameKz: "Бұл сектор үшін уақытша шектеуді алып тастағыңыз келетініне сенімдісіз бе?",
        nameEn: 'Are you sure you want to remove the temporary restriction for this sector?',
    },
    'Снять временные ограничения': {
        nameRu: "Снять временные ограничения",
        nameKz: "Уақытша шектеулерді алып тастау",
        nameEn: 'Remove temporary restrictions',
    },
    'Да, снять': {
        nameRu: "Да, снять",
        nameKz: "Иә, алып тастау",
        nameEn: 'Yes, remove',
    },
    'выбранных секторов?': {
        nameRu: "выбранных секторов?",
        nameKz: "таңдалған секторлар?",
        nameEn: 'selected sectors?',
    },
    'Начало периода': {
        nameRu: "Начало периода",
        nameKz: "Кезеңнің басы",
        nameEn: 'Period start',
    },
    'Конец периода': {
        nameRu: "Конец периода",
        nameKz: "Кезеңнің соңы",
        nameEn: 'Period end',
    },
    'Сбросить фильтры': {
        nameRu: "Сбросить фильтры",
        nameKz: "Сүзгілерді тазалау",
        nameEn: 'Reset filters',
    },
    'Начало ограничения дата': {
        nameRu: "Начало ограничения дата",
        nameKz: "Шектеудің басталу күні",
        nameEn: 'Restriction start date',
    },
    'Начало ограничения время': {
        nameRu: "Начало ограничения время",
        nameKz: "Шектеудің басталу уақыты",
        nameEn: 'Restriction start time',
    },
    'Завершение ограничения дата': {
        nameRu: "Завершение ограничения дата",
        nameKz: "Шектеудің аяқталу күні",
        nameEn: 'Restriction end date',
    },
    'Завершение ограничения время': {
        nameRu: "Завершение ограничения время",
        nameKz: "Шектеудің аяқталу уақыты",
        nameEn: 'Restriction end time',
    },
    'Список зон': {
        nameRu: "Список зон",
        nameKz: "Аймақтар тізімі",
        nameEn: 'Zone list',
    },
    'ID:': {
        nameRu: "ID:",
        nameKz: "ID:",
        nameEn: 'ID:',
    },
    'Полет min h': {
        nameRu: "Полет min h",
        nameKz: "Ұшу мин. б.",
        nameEn: 'Flight min h',
    },
    'Полет max h': {
        nameRu: "Полет max h",
        nameKz: "Ұшу макс. б.",
        nameEn: 'Flight max h',
    },
    'Здания max h': {
        nameRu: "Здания max h",
        nameKz: "Ғимараттар макс. б.",
        nameEn: 'Buildings max h',
    },
    'Деревья max h': {
        nameRu: "Деревья max h",
        nameKz: "Ағаштар макс. б.",
        nameEn: 'Trees max h',
    },
    'ЛЭП max h': {
        nameRu: "ЛЭП max h",
        nameKz: "ЭЖБ макс. б.",
        nameEn: 'Power lines max h',
    },
    'Выберите': {
        nameRu: "Выберите",
        nameKz: "Таңдаңыз",
        nameEn: 'Select',
    },
    'Выберите районы': {
        nameRu: "Выберите районы",
        nameKz: "Аудандарды таңдаңыз",
        nameEn: 'Select districts',
    },
    'Выберите типы зон': {
        nameRu: "Выберите типы зон",
        nameKz: "Аймақ түрлерін таңдаңыз",
        nameEn: 'Select zone types',
    },
    'Выберите ограничения': {
        nameRu: "Выберите ограничения",
        nameKz: "Шектеулерді таңдаңыз",
        nameEn: 'Select restrictions',
    },
    'Выберите разрешение': {
        nameRu: "Выберите разрешение",
        nameKz: "Рұқсатты таңдаңыз",
        nameEn: 'Select permission',
    },
    'Выберите дни': {
        nameRu: "Выберите дни",
        nameKz: "Күндерді таңдаңыз",
        nameEn: 'Select days',
    },
    'Вы уверены, что хотите снять временные ограничения для': {
        nameRu: "Вы уверены, что хотите снять временные ограничения для",
        nameKz: "Сіз уақытша шектеулерді алып тастағыңыз келетініне сенімдісіз бе",
        nameEn: 'Are you sure you want to remove temporary restrictions for',
    },
    'Заявка в архиве': {
        nameRu: "Заявка в архиве",
        nameKz: "Өтініш мұрағатта",
        nameEn: 'Application archived',
    },

    'Заявка была отклонена модератором.': {
        nameRu: "Заявка была отклонена модератором.",
        nameKz: "Өтініш модератор тарапынан қабылданбады.",
        nameEn: 'The application was rejected by the moderator.',
    },
    'Заявка находится в архиве.': {
        nameRu: "Заявка находится в архиве.",
        nameKz: "Өтініш мұрағатта.",
        nameEn: 'The application is archived.',
    },
    'Заявки на полеты': {
        nameRu: "Заявки на полеты",
        nameKz: "Ұшуға арналған өтініштер",
        nameEn: 'Flight applications',
    },
    'Управление заявками на полеты дронов': {
        nameRu: "Управление заявками на полеты дронов",
        nameKz: "Дрондардың ұшуға арналған өтініштерін басқару",
        nameEn: 'Manage drone flight applications',
    },
    'Все заявки': {
        nameRu: "Все заявки",
        nameKz: "Барлық өтініштер",
        nameEn: 'All applications',
    },
    'Согласованные': {
        nameRu: "Согласованные",
        nameKz: "Мақұлданған",
        nameEn: 'Approved',
    },
    'Отказанные': {
        nameRu: "Отказанные",
        nameKz: "Қабылданбаған",
        nameEn: 'Rejected',
    },
    'Отказ': {
        nameRu: "Отказ",
        nameKz: "Қабылдамау",
        nameEn: 'Rejection',
    },
    'Принять': {
        nameRu: "Принять",
        nameKz: "Қабылдау",
        nameEn: 'Accept',
    },
    'Причина отказа': {
        nameRu: "Причина отказа",
        nameKz: "Қабылдамау себебі",
        nameEn: 'Reason for rejection',
    },
    'Отклонить': {
        nameRu: "Отклонить",
        nameKz: "Қабылдамау",
        nameEn: 'Reject',
    },
    'Укажите причину отказа заявки': {
        nameRu: "Укажите причину отказа заявки",
        nameKz: "Өтінішті қабылдамау себебін көрсетіңіз",
        nameEn: 'Specify the application rejection reason',
    },
    'Подтверждение согласования': {
        nameRu: "Подтверждение согласования",
        nameKz: "Мақұлдауды растау",
        nameEn: 'Confirm approval',
    },
    'Вы уверены, что хотите согласовать эту заявку?': {
        nameRu: "Вы уверены, что хотите согласовать эту заявку?",
        nameKz: "Бұл өтінішті мақұлдағыңыз келетініне сенімдісіз бе?",
        nameEn: 'Are you sure you want to approve this application?',
    },
    'Согласовать': {
        nameRu: "Согласовать",
        nameKz: "Мақұлдау",
        nameEn: 'Approve',
    },
    'Укажите причину отказа': {
        nameRu: "Укажите причину отказа",
        nameKz: "Қабылдамау себебін көрсетіңіз",
        nameEn: 'Specify the rejection reason',
    },
    'Возврат заявки на проверку': {
        nameRu: "Возврат заявки на проверку",
        nameKz: "Өтінішті тексеруге қайтару",
        nameEn: 'Return application for review',
    },
    'Вы уверены, что хотите вернуть эту заявку на проверку? Статус заявки будет изменен на "В ожидании".': {
        nameRu: "Вы уверены, что хотите вернуть эту заявку на проверку? Статус заявки будет изменен на \"В ожидании\".",
        nameKz: "Бұл өтінішті тексеруге қайтарғыңыз келетініне сенімдісіз бе? Өтініш мәртебесі \"Күтуде\" деп өзгереді.",
        nameEn: 'Are you sure you want to return this application for review? The application status will be changed to "Pending".',
    },
    'Статус обновлен, но не удалось сохранить комментарий модератора. Проверьте, что поле moderator_comment существует в таблице flights.': {
        nameRu: "Статус обновлен, но не удалось сохранить комментарий модератора. Проверьте, что поле moderator_comment существует в таблице flights.",
        nameKz: "Мәртебе жаңартылды, бірақ модератордың түсініктемесін сақтау мүмкін болмады. flights кестесінде moderator_comment өрісі бар екенін тексеріңіз.",
        nameEn: 'Status updated, but the moderator comment could not be saved. Check that the moderator_comment field exists in the flights table.',
    },
    'Не удалось обновить статус заявки. Проверьте консоль для деталей.': {
        nameRu: "Не удалось обновить статус заявки. Проверьте консоль для деталей.",
        nameKz: "Өтініш мәртебесін жаңарту мүмкін болмады. Толық ақпарат үшін консольді тексеріңіз.",
        nameEn: 'Failed to update application status. Check the console for details.',
    },
    'Не удалось загрузить детали заявки': {
        nameRu: "Не удалось загрузить детали заявки",
        nameKz: "Өтініш деректерін жүктеу мүмкін болмады",
        nameEn: 'Failed to load application details',
    },
    'Ошибка обновления статуса заявки': {
        nameRu: "Ошибка обновления статуса заявки",
        nameKz: "Өтініш мәртебесін жаңарту қатесі",
        nameEn: 'Application status update error',
    },
    'Неизвестная ошибка': {
        nameRu: "Неизвестная ошибка",
        nameKz: "Белгісіз қате",
        nameEn: 'Unknown error',
    },

    '3D Высоты': {
        nameRu: "3D Высоты",
        nameKz: "3D Биіктіктер",
        nameEn: '3D Altitudes',
    },
    'Cпец разрешение': {
        nameRu: "Cпец разрешение",
        nameKz: "Арнайы рұқсат",
        nameEn: 'Special permit',
    },
    'БИИН': {
        nameRu: "БИИН",
        nameKz: "БИИН",
        nameEn: 'BIIN',
    },
    'Без ограничений': {
        nameRu: "Без ограничений",
        nameKz: "Шектеусіз",
        nameEn: 'No restrictions',
    },
    'Безопасность полётов': {
        nameRu: "Безопасность полётов",
        nameKz: "Ұшу қауіпсіздігі",
        nameEn: 'Flight safety',
    },
    'В ожидании': {
        nameRu: "В ожидании",
        nameKz: "Күтуде",
        nameEn: 'Pending',
    },
    'Введите': {
        nameRu: "Введите",
        nameKz: "Енгізіңіз",
        nameEn: 'Enter',
    },
    'Введите высоту': {
        nameRu: "Введите высоту",
        nameKz: "Биіктікті енгізіңіз",
        nameEn: 'Enter altitude',
    },
    'Введите комментарий': {
        nameRu: "Введите комментарий",
        nameKz: "Пікір енгізіңіз",
        nameEn: 'Enter comment',
    },
    'Введите серийный номер': {
        nameRu: "Введите серийный номер",
        nameKz: "Сериялық нөмірді енгізіңіз",
        nameEn: 'Enter serial number',
    },
    'Вернуть на проверку': {
        nameRu: "Вернуть на проверку",
        nameKz: "Тексеруге қайтару",
        nameEn: 'Return for review',
    },
    'Воскресенье': {
        nameRu: "Воскресенье",
        nameKz: "Жексенбі",
        nameEn: 'Sunday',
    },
    'Временные ограничения': {
        nameRu: "Временные ограничения",
        nameKz: "Уақытша шектеулер",
        nameEn: 'Temporary restrictions',
    },
    'Время полетов': {
        nameRu: "Время полетов",
        nameKz: "Ұшу уақыты",
        nameEn: 'Flight time',
    },
    'Вс': {
        nameRu: "Вс",
        nameKz: "Жс",
        nameEn: 'Sun',
    },
    'Все дни': {
        nameRu: "Все дни",
        nameKz: "Барлық күндер",
        nameEn: 'All days',
    },
    'Вт': {
        nameRu: "Вт",
        nameKz: "Сс",
        nameEn: 'Tue',
    },
    'Вторник': {
        nameRu: "Вторник",
        nameKz: "Сейсенбі",
        nameEn: 'Tuesday',
    },
    'Вы уверены, что хотите удалить пользователя': {
        nameRu: "Вы уверены, что хотите удалить пользователя",
        nameKz: "Пайдаланушыны жоюға сенімдісіз бе?",
        nameEn: 'Are you sure you want to delete the user',
    },
    'Выберите время начала': {
        nameRu: "Выберите время начала",
        nameKz: "Басталу уақытын таңдаңыз",
        nameEn: 'Select start time',
    },
    'Выберите время окончания': {
        nameRu: "Выберите время окончания",
        nameKz: "Аяқталу уақытын таңдаңыз",
        nameEn: 'Select end time',
    },
    'Выберите дату начала': {
        nameRu: "Выберите дату начала",
        nameKz: "Басталу күнін таңдаңыз",
        nameEn: 'Select start date',
    },
    'Выберите дату окончания (необязательно)': {
        nameRu: "Выберите дату окончания (необязательно)",
        nameKz: "Аяқталу күнін таңдаңыз (міндетті емес)",
        nameEn: 'Select end date (optional)',
    },
    'Выберите дрон для добавления': {
        nameRu: "Выберите дрон для добавления",
        nameKz: "Қосу үшін дронды таңдаңыз",
        nameEn: 'Select a drone to add',
    },
    'Выберите назначение': {
        nameRu: "Выберите назначение",
        nameKz: "Мақсатты таңдаңыз",
        nameEn: 'Select purpose',
    },
    'Выберите тип зоны': {
        nameRu: "Выберите тип зоны",
        nameKz: "Аудан түрін таңдаңыз",
        nameEn: 'Select zone type',
    },
    'Выберите тип лица': {
        nameRu: "Выберите тип лица",
        nameKz: "Тұлға түрін таңдаңыз",
        nameEn: 'Select person type',
    },
    'Выберите типы': {
        nameRu: "Выберите типы",
        nameKz: "Түрлерді таңдаңыз",
        nameEn: 'Select types',
    },
    'Выбранный период:': {
        nameRu: "Выбранный период:",
        nameKz: "Таңдалған кезең:",
        nameEn: 'Selected period:',
    },
    'Выбрать область': {
        nameRu: "Выбрать область",
        nameKz: "Ауданды таңдау",
        nameEn: 'Select area',
    },
    'Высота полёта (м)': {
        nameRu: "Высота полёта (м)",
        nameKz: "Ұшу биіктігі (м)",
        nameEn: 'Flight altitude (m)',
    },
    'Гос собственность': {
        nameRu: "Гос собственность",
        nameKz: "Мемлекеттік меншік",
        nameEn: 'State property',
    },
    'Дата начала': {
        nameRu: "Дата начала",
        nameKz: "Басталу күні",
        nameEn: 'Start date',
    },
    'Дата окончания': {
        nameRu: "Дата окончания",
        nameKz: "Аяқталу күні",
        nameEn: 'End date',
    },
    'Деревья': {
        nameRu: "Деревья",
        nameKz: "Ағаштар",
        nameEn: 'Trees',
    },
    'Дни': {
        nameRu: "Дни",
        nameKz: "Күндер",
        nameEn: 'Days',
    },
    'Дни недели': {
        nameRu: "Дни недели",
        nameKz: "Апта күндері",
        nameEn: 'Days of the week',
    },
    'Добавить': {
        nameRu: "Добавить",
        nameKz: "Қосу",
        nameEn: 'Add',
    },
    'Добавить маршрут': {
        nameRu: "Добавить маршрут",
        nameKz: "Маршрут қосу",
        nameEn: 'Add route',
    },
    'Добавить дрон': {
        nameRu: "Добавить дрон",
        nameKz: "Дрон қосу",
        nameEn: 'Add drone',
    },
    'Есть': {
        nameRu: "Есть",
        nameKz: "Бар",
        nameEn: 'Available',
    },
    'Запланировать полет': {
        nameRu: "Запланировать полет",
        nameKz: "Ұшу жоспарлау",
        nameEn: 'Schedule flight',
    },
    'Запретная зона': {
        nameRu: "Запретная зона",
        nameKz: "Тыйым салынған аймақ",
        nameEn: 'Prohibited zone',
    },
    'Зарегистрировано устройств': {
        nameRu: "Зарегистрировано устройств",
        nameKz: "Тіркелген құрылғылар",
        nameEn: 'Registered devices',
    },
    'Заявка возвращена на проверку': {
        nameRu: "Заявка возвращена на проверку",
        nameKz: "Өтініш тексеруге қайтарылды",
        nameEn: 'Application returned for review',
    },
    'Заявка отклонена': {
        nameRu: "Заявка отклонена",
        nameKz: "Өтініш қабылданбады",
        nameEn: 'Application rejected',
    },
    'Заявка успешно согласована': {
        nameRu: "Заявка успешно согласована",
        nameKz: "Өтініш сәтті келісілді",
        nameEn: 'Application approved successfully',
    },
    'Заңды атауы': {
        nameRu: "Заңды атауы",
        nameKz: "Заңды атауы",
        nameEn: 'Legal name',
    },
    'Здания': {
        nameRu: "Здания",
        nameKz: "Ғимараттар",
        nameEn: 'Buildings',
    },
    'Комментарий': {
        nameRu: "Комментарий",
        nameKz: "Пікір",
        nameEn: 'Comment',
    },
    'Комментарий модератора': {
        nameRu: "Комментарий модератора",
        nameKz: "Модератор пікірі",
        nameEn: 'Moderator comment',
    },
    'ЛЭП': {
        nameRu: "ЛЭП",
        nameKz: "ЖЭЛ",
        nameEn: 'Power lines',
    },
    'Макс. высота': {
        nameRu: "Макс. высота",
        nameKz: "Макс. биіктік",
        nameEn: 'Max. altitude',
    },
    'Макс. высота ЛЭП': {
        nameRu: "Макс. высота ЛЭП",
        nameKz: "Макс. ЖЭЛ биіктігі",
        nameEn: 'Max. power line height',
    },
    'Макс. высота деревьев': {
        nameRu: "Макс. высота деревьев",
        nameKz: "Макс. ағаш биіктігі",
        nameEn: 'Max. tree height',
    },
    'Макс. высота зданий': {
        nameRu: "Макс. высота зданий",
        nameKz: "Макс. ғимарат биіктігі",
        nameEn: 'Max. building height',
    },
    'Макс. высота полета': {
        nameRu: "Макс. высота полета",
        nameKz: "Макс. ұшу биіктігі",
        nameEn: 'Max. flight altitude',
    },
    'Мин. высота полета': {
        nameRu: "Мин. высота полета",
        nameKz: "Мин. ұшу биіктігі",
        nameEn: 'Min. flight altitude',
    },
    'Название': {
        nameRu: "Название",
        nameKz: "Атауы",
        nameEn: 'Name',
    },
    'Не требуется': {
        nameRu: "Не требуется",
        nameKz: "Талап етілмейді",
        nameEn: 'Not required',
    },
    'Не удалось загрузить данные заявки': {
        nameRu: "Не удалось загрузить данные заявки",
        nameKz: "Өтініш деректерін жүктеу мүмкін болмады",
        nameEn: 'Failed to load application data',
    },
    'Не удалось загрузить заявки': {
        nameRu: "Не удалось загрузить заявки",
        nameKz: "Өтініштерді жүктеу мүмкін болмады",
        nameEn: 'Failed to load applications',
    },
    'Не удалось загрузить полеты': {
        nameRu: "Не удалось загрузить полеты",
        nameKz: "Ұшуларды жүктеу мүмкін болмады",
        nameEn: 'Failed to load flights',
    },
    'Не удалось загрузить пользователей': {
        nameRu: "Не удалось загрузить пользователей",
        nameKz: "Пайдаланушыларды жүктеу мүмкін болмады",
        nameEn: 'Failed to load users',
    },
    'Нет доступа': {
        nameRu: "Нет доступа",
        nameKz: "Қол жетімсіз",
        nameEn: 'No access',
    },
    'Нет заявок за выбранный период': {
        nameRu: "Нет заявок за выбранный период",
        nameKz: "Таңдалған кезеңде өтініштер жоқ",
        nameEn: 'No applications for the selected period',
    },
    'Нет согласованных заявок за выбранный период': {
        nameRu: "Нет согласованных заявок за выбранный период",
        nameKz: "Таңдалған кезеңде келісілген өтініштер жоқ",
        nameEn: 'No approved applications for the selected period',
    },
    'ОК': {
        nameRu: "ОК",
        nameKz: "ОК",
        nameEn: 'OK',
    },
    'Обновить данные': {
        nameRu: "Обновить данные",
        nameKz: "Деректерді жаңарту",
        nameEn: 'Refresh data',
    },
    'Ограничения по дням недели для каждого сектора:': {
        nameRu: "Ограничения по дням недели для каждого сектора:",
        nameKz: "Әр сектор үшін апта күндері бойынша шектеулер:",
        nameEn: 'Restrictions by days of the week for each sector:',
    },
    'Ожидают': {
        nameRu: "Ожидают",
        nameKz: "Күтуде",
        nameEn: 'Pending',
    },
    'Описание': {
        nameRu: "Описание",
        nameKz: "Сипаттама",
        nameEn: 'Description',
    },
    'Отказано': {
        nameRu: "Отказано",
        nameKz: "Қабылданбады",
        nameEn: 'Rejected',
    },
    'Ошибка обновления:': {
        nameRu: "Ошибка обновления:",
        nameKz: "Жаңарту қатесі:",
        nameEn: 'Update error:',
    },
    'Планирование полёта недоступно в закрытой зоне': {
        nameRu: "Планирование полёта недоступно в закрытой зоне",
        nameKz: "Жабық аймақта ұшу жоспарлау қолжетімсіз",
        nameEn: 'Flight planning is unavailable in a closed zone',
    },
    'Планируемая дата и время': {
        nameRu: "Планируемая дата и время",
        nameKz: "Жоспарланған күн мен уақыт",
        nameEn: 'Planned date and time',
    },
    'Пн': {
        nameRu: "Пн",
        nameKz: "Дс",
        nameEn: 'Mon',
    },
    'Подано заявок на полет': {
        nameRu: "Подано заявок на полет",
        nameKz: "Ұшуға берілген өтініштер",
        nameEn: 'Flight applications submitted',
    },
    'Подтверждение удаления': {
        nameRu: "Подтверждение удаления",
        nameKz: "Жоюды растау",
        nameEn: 'Confirm deletion',
    },
    'Поиск по ID': {
        nameRu: "Поиск по ID",
        nameKz: "ID бойынша іздеу",
        nameEn: 'Search by ID',
    },
    'Поиск по email, имени, ИИН/БИИН, телефону': {
        nameRu: "Поиск по email, имени, ИИН/БИИН, телефону",
        nameKz: "Email, аты, ЖСН/БИИН, телефон бойынша іздеу",
        nameEn: 'Search by email, name, IIN/BIIN, phone',
    },
    'Пользователи': {
        nameRu: "Пользователи",
        nameKz: "Пайдаланушылар",
        nameEn: 'Users',
    },
    'Пользователь успешно обновлен': {
        nameRu: "Пользователь успешно обновлен",
        nameKz: "Пайдаланушы сәтті жаңартылды",
        nameEn: 'User updated successfully',
    },
    'Пользователь успешно удален': {
        nameRu: "Пользователь успешно удален",
        nameKz: "Пайдаланушы сәтті жойылды",
        nameEn: 'User deleted successfully',
    },
    'Понедельник': {
        nameRu: "Понедельник",
        nameKz: "Дүйсенбі",
        nameEn: 'Monday',
    },
    'Приблизить': {
        nameRu: "Приблизить",
        nameKz: "Жақындату",
        nameEn: 'Zoom in',
    },
    'Пт': {
        nameRu: "Пт",
        nameKz: "Жм",
        nameEn: 'Fri',
    },
    'Пятница': {
        nameRu: "Пятница",
        nameKz: "Жұма",
        nameEn: 'Friday',
    },
    'Разрешённая зона': {
        nameRu: "Разрешённая зона",
        nameKz: "Рұқсат етілген аймақ",
        nameEn: 'Permitted zone',
    },
    'Район': {
        nameRu: "Район",
        nameKz: "Аудан",
        nameEn: 'District',
    },
    'Район:': {
        nameRu: "Район:",
        nameKz: "Аудан:",
        nameEn: 'District:',
    },
    'Регистрация дронов': {
        nameRu: "Регистрация дронов",
        nameKz: "Дрондарды тіркеу",
        nameEn: 'Drone registration',
    },
    'Редактирование ограничений': {
        nameRu: "Редактирование ограничений",
        nameKz: "Шектеулерді өңдеу",
        nameEn: 'Edit restrictions',
    },
    'Редактирование пользователя': {
        nameRu: "Редактирование пользователя",
        nameKz: "Пайдаланушыны өңдеу",
        nameEn: 'Edit user',
    },
    'Редактирование статуса': {
        nameRu: "Редактирование статуса",
        nameKz: "Мәртебені өңдеу",
        nameEn: 'Edit status',
    },
    'Редактировать полигон': {
        nameRu: "Редактировать полигон",
        nameKz: "Полигонды өңдеу",
        nameEn: 'Edit polygon',
    },
    'Роль': {
        nameRu: "Роль",
        nameKz: "Рөл",
        nameEn: 'Role',
    },
    'Роль успешно изменена': {
        nameRu: "Роль успешно изменена",
        nameKz: "Рөл сәтті өзгертілді",
        nameEn: 'Role changed successfully',
    },
    'Сб': {
        nameRu: "Сб",
        nameKz: "Сб",
        nameEn: 'Sat',
    },
    'Сбросить': {
        nameRu: "Сбросить",
        nameKz: "Тазалау",
        nameEn: 'Reset',
    },
    'Сбросить все фильтры и сортировку': {
        nameRu: "Сбросить все фильтры и сортировку",
        nameKz: "Барлық сүзгілер мен сұрыптауды тазалау",
        nameEn: 'Reset all filters and sorting',
    },
    'Сводная информация': {
        nameRu: "Сводная информация",
        nameKz: "Жиынтық ақпарат",
        nameEn: 'Summary information',
    },
    'Сектора': {
        nameRu: "Сектора",
        nameKz: "Секторлар",
        nameEn: 'Sectors',
    },
    'Снять ограничения': {
        nameRu: "Снять ограничения",
        nameKz: "Шектеулерді алып тастау",
        nameEn: 'Remove restrictions',
    },
    'Согласованно': {
        nameRu: "Согласованно",
        nameKz: "Келісілді",
        nameEn: 'Approved',
    },
    'Согласовано': {
        nameRu: "Согласовано",
        nameKz: "Келісілді",
        nameEn: 'Approved',
    },
    'Ср': {
        nameRu: "Ср",
        nameKz: "Ср",
        nameEn: 'Wed',
    },
    'Среда': {
        nameRu: "Среда",
        nameKz: "Сәрсенбі",
        nameEn: 'Wednesday',
    },
    'Суббота': {
        nameRu: "Суббота",
        nameKz: "Сенбі",
        nameEn: 'Saturday',
    },
    'Текущая дата:': {
        nameRu: "Текущая дата:",
        nameKz: "Ағымдағы күн:",
        nameEn: 'Current date:',
    },
    'Тип': {
        nameRu: "Тип",
        nameKz: "Түрі",
        nameEn: 'Type',
    },
    'Тип действия': {
        nameRu: "Тип действия",
        nameKz: "Әрекет түрі",
        nameEn: 'Action type',
    },
    'Тип зоны': {
        nameRu: "Тип зоны",
        nameKz: "Аудан түрі",
        nameEn: 'Zone type',
    },
    'Требуется': {
        nameRu: "Требуется",
        nameKz: "Талап етіледі",
        nameEn: 'Required',
    },
    'У вас нет прав для присвоения этой роли': {
        nameRu: "У вас нет прав для присвоения этой роли",
        nameKz: "Сізде бұл рөлді тағайындауға құқық жоқ",
        nameEn: 'You do not have permission to assign this role',
    },
    'Частная собственность': {
        nameRu: "Частная собственность",
        nameKz: "Жеке меншік",
        nameEn: 'Private property',
    },
    'Четверг': {
        nameRu: "Четверг",
        nameKz: "Бейсенбі",
        nameEn: 'Thursday',
    },
    'Чт': {
        nameRu: "Чт",
        nameKz: "Бс",
        nameEn: 'Thu',
    },
    'Это действие необратимо.': {
        nameRu: "Это действие необратимо.",
        nameKz: "Бұл әрекет қайтымсыз.",
        nameEn: 'This action is irreversible.',
    },
    'нет': {
        nameRu: "нет",
        nameKz: "жоқ",
        nameEn: 'no',
    },
    'период задевает запрещённые дни:': {
        nameRu: "период задевает запрещённые дни:",
        nameKz: "кезең тыйым салынған күндерге тиеді:",
        nameEn: 'the period includes prohibited days:',
    },
    'разрешено:': {
        nameRu: "разрешено:",
        nameKz: "рұқсат етілген:",
        nameEn: 'allowed:',
    },
    'Қz': {
        nameRu: "Қz",
        nameKz: "Қz",
        nameEn: 'Kz',
    },
    'Қазақша': {
        nameRu: "Қазақша",
        nameKz: "Қазақша",
        nameEn: 'Kazakh',
    },
    'Подтверждение редактирования': {
        nameRu: "Подтверждение редактирования",
        nameKz: "Өңдеуді растау",
        nameEn: 'Confirm editing',
    },
    'Вы уверены, что хотите сохранить изменения в заявке?': {
        nameRu: "Вы уверены, что хотите сохранить изменения в заявке?",
        nameKz: "Сіз өтініштегі өзгерістерді сақтағыңыз келетініне сенімдісіз бе?",
        nameEn: 'Are you sure you want to save changes to the application?',
    },
    'Заявка успешно обновлена': {
        nameRu: "Заявка успешно обновлена",
        nameKz: "Өтініш сәтті жаңартылды",
        nameEn: 'Application updated successfully',
    },
    'Нет запланированных полетов на выбранную дату': {
        nameRu: "Нет запланированных полетов на выбранную дату",
        nameKz: "Таңдалған күнге жоспарланған ұшулар жоқ",
        nameEn: 'No scheduled flights for the selected date',
    },
    'Запланировать первый полет': {
        nameRu: "Запланировать первый полет",
        nameKz: "Алғашқы ұшу жоспарын құру",
        nameEn: 'Schedule first flight',
    },
    'Ошибка загрузки дронов': {
        nameRu: "Ошибка загрузки дронов",
        nameKz: "Дрондарды жүктеу қатесі",
        nameEn: 'Error loading drones',
    },
    'Повторить': {
        nameRu: "Повторить",
        nameKz: "Қайталау",
        nameEn: 'Retry',
    },
    'Ошибка загрузки полетов': {
        nameRu: "Ошибка загрузки полетов",
        nameKz: "Ұшуларды жүктеу қатесі",
        nameEn: 'Error loading flights',
    },
    'Только согласованные заявки': {
        nameRu: "Только согласованные заявки",
        nameKz: "Тек келісілген өтінімдер",
        nameEn: 'Approved applications only',
    },
    'Всего записей': {
        nameRu: "Всего записей",
        nameKz: "Барлық жазбалар",
        nameEn: 'Total records',
    },
    'Список заявок': {
        nameRu: "Список заявок",
        nameKz: "Өтінімдер тізімі",
        nameEn: 'Application list',
    },
    'ID': {
        nameRu: "ID",
        nameKz: "ID",
        nameEn: 'ID',
    },
    'Поиск по заголовку': {
        nameRu: "Поиск по заголовку",
        nameKz: "Тақырып бойынша іздеу",
        nameEn: 'Search by title',
    },
    'Добавить новость': {
        nameRu: "Добавить новость",
        nameKz: "Жаңалық қосу",
        nameEn: 'Add news item',
    },
    'Всего': {
        nameRu: "Всего",
        nameKz: "Барлығы",
        nameEn: 'Total',
    },
    'Просмотр новости': {
        nameRu: "Просмотр новости",
        nameKz: "Жаңалықты көру",
        nameEn: 'View news item',
    },
    'Не опубликовано': {
        nameRu: "Не опубликовано",
        nameKz: "Жарияланбаған",
        nameEn: 'Not published',
    },
    'Редактирование новости': {
        nameRu: "Редактирование новости",
        nameKz: "Жаңалықты өңдеу",
        nameEn: 'Edit news item',
    },
    'Добавление новости': {
        nameRu: "Добавление новости",
        nameKz: "Жаңалық қосу",
        nameEn: 'Add news item',
    },
    'Введите заголовок': {
        nameRu: "Введите заголовок",
        nameKz: "Тақырыпты енгізіңіз",
        nameEn: 'Enter title',
    },
    'Заголовок новости': {
        nameRu: "Заголовок новости",
        nameKz: "Жаңалық тақырыбы",
        nameEn: 'News title',
    },
    'Краткое описание новости': {
        nameRu: "Краткое описание новости",
        nameKz: "Жаңалықтың қысқаша сипаттамасы",
        nameEn: 'Short news description',
    },
    'Введите содержание': {
        nameRu: "Введите содержание",
        nameKz: "Мазмұнды енгізіңіз",
        nameEn: 'Enter content',
    },
    'Содержание новости': {
        nameRu: "Содержание новости",
        nameKz: "Жаңалық мазмұны",
        nameEn: 'News content',
    },
    'Загрузить изображение': {
        nameRu: "Загрузить изображение",
        nameKz: "Суретті жүктеу",
        nameEn: 'Upload image',
    },
    'Или введите URL изображения': {
        nameRu: "Или введите URL изображения",
        nameKz: "Немесе сурет URL мекенжайын енгізіңіз",
        nameEn: 'Or enter image URL',
    },
    'Подпись к изображению': {
        nameRu: "Подпись к изображению",
        nameKz: "Суретке жазу",
        nameEn: 'Image caption',
    },
    'Загрузить видео': {
        nameRu: "Загрузить видео",
        nameKz: "Бейнені жүктеу",
        nameEn: 'Upload video',
    },
    'Или введите URL видео': {
        nameRu: "Или введите URL видео",
        nameKz: "Немесе бейне URL мекенжайын енгізіңіз",
        nameEn: 'Or enter video URL',
    },
    'Полиция': {
        nameRu: "Полиция",
        nameKz: "Полиция",
        nameEn: 'Police',
    },
    'Геометрия сектора отсутствует': {
        nameRu: "Геометрия сектора отсутствует",
        nameKz: "Сектор геометриясы жоқ",
        nameEn: 'Sector geometry is missing',
    },
    'Загрузка полигонов...': {
        nameRu: "Загрузка полигонов...",
        nameKz: "Полигондарды жүктеу...",
        nameEn: 'Loading polygons...',
    },
    'Что-то пошло не так': {
        nameRu: "Что-то пошло не так",
        nameKz: "Бір нәрсе дұрыс болмады",
        nameEn: 'Something went wrong',
    },
    'Произошла непредвиденная ошибка. Пожалуйста, попробуйте обновить страницу.': {
        nameRu: "Произошла непредвиденная ошибка. Пожалуйста, попробуйте обновить страницу.",
        nameKz: "Күтпеген қате орын алды. Бетті жаңартып көріңіз.",
        nameEn: 'An unexpected error occurred. Please try refreshing the page.',
    },
    'Обновить страницу': {
        nameRu: "Обновить страницу",
        nameKz: "Бетті жаңарту",
        nameEn: 'Refresh page',
    },
    'Неверный email или пароль': {
        nameRu: "Неверный email или пароль",
        nameKz: "Дұрыс емес email немесе құпия сөз",
        nameEn: 'Invalid email or password',
    },
    'Английский': {
        nameRu: 'Английский',
        nameKz: 'Ағылшынша',
        nameEn: 'English',
    },
    'En': {
        nameRu: 'En',
        nameKz: 'En',
        nameEn: 'En',
    },
    'Название (EN)': {
        nameRu: 'Название (EN)',
        nameKz: 'Атауы (EN)',
        nameEn: 'Name (EN)',
    },
    'Произошла ошибка': {
        nameRu: 'Произошла ошибка',
        nameKz: 'Қате орын алды',
        nameEn: 'An error occurred',
    },
    'Операция выполнена успешно': {
        nameRu: 'Операция выполнена успешно',
        nameKz: 'Операция сәтті орындалды',
        nameEn: 'Operation completed successfully',
    },
    'Максимально допустимая высота': {
        nameRu: 'Максимально допустимая высота',
        nameKz: 'Рұқсат етілген ең жоғары биіктік',
        nameEn: 'Maximum allowed altitude',
    },
    'Полеты запрещены в': {
        nameRu: 'Полеты запрещены в',
        nameKz: 'Ұшуға тыйым салынады',
        nameEn: 'Flights are prohibited on',
    },
    'Выберите другой день недели.': {
        nameRu: 'Выберите другой день недели.',
        nameKz: 'Басқа апта күнін таңдаңыз.',
        nameEn: 'Please choose another day of the week.',
    },
    'Полеты разрешены только с': {
        nameRu: 'Полеты разрешены только с',
        nameKz: 'Ұшуға рұқсат тек',
        nameEn: 'Flights are allowed only from',
    },
    'Выберите другое время.': {
        nameRu: 'Выберите другое время.',
        nameKz: 'Басқа уақытты таңдаңыз.',
        nameEn: 'Please choose another time.',
    },
    'Минимальная длина': {
        nameRu: 'Минимальная длина',
        nameKz: 'Ең аз ұзындық',
        nameEn: 'Minimum length',
    },
    'Максимальная длина': {
        nameRu: 'Максимальная длина',
        nameKz: 'Ең көп ұзындық',
        nameEn: 'Maximum length',
    },
    'Минимальное значение': {
        nameRu: 'Минимальное значение',
        nameKz: 'Ең аз мән',
        nameEn: 'Minimum value',
    },
    'Максимальное значение': {
        nameRu: 'Максимальное значение',
        nameKz: 'Ең көп мән',
        nameEn: 'Maximum value',
    },
    'Маршрут полета успешно зарегистрирован': {
        nameRu: 'Маршрут полета успешно зарегистрирован',
        nameKz: 'Ұшу маршруты сәтті тіркелді',
        nameEn: 'Flight route registered successfully',
    },
    'Ошибка регистрации маршрута полета': {
        nameRu: 'Ошибка регистрации маршрута полета',
        nameKz: 'Ұшу маршрутын тіркеу қатесі',
        nameEn: 'Flight route registration error',
    },
    'Не найдено секторов в выбранной области. Выберите секторы на карте или нарисуйте область/маршрут заново.': {
        nameRu: 'Не найдено секторов в выбранной области. Выберите секторы на карте или нарисуйте область/маршрут заново.',
        nameKz: 'Таңдалған аймақта секторлар табылмады. Картадан секторларды таңдаңыз немесе аймақ/маршрутты қайта сызыңыз.',
        nameEn: 'No sectors found in the selected area. Select sectors on the map or draw the area/route again.',
    },
    'Выберите дату полета': {
        nameRu: 'Выберите дату полета',
        nameKz: 'Ұшу күнін таңдаңыз',
        nameEn: 'Select flight date',
    },
    'Выберите время полета': {
        nameRu: 'Выберите время полета',
        nameKz: 'Ұшу уақытын таңдаңыз',
        nameEn: 'Select flight time',
    },
    'Выберите дату окончания': {
        nameRu: 'Выберите дату окончания',
        nameKz: 'Аяқталу күнін таңдаңыз',
        nameEn: 'Select end date',
    },
    'Выберите назначение полета': {
        nameRu: 'Выберите назначение полета',
        nameKz: 'Ұшу мақсатын таңдаңыз',
        nameEn: 'Select flight purpose',
    },
    'Введите описание': {
        nameRu: 'Введите описание',
        nameKz: 'Сипаттаманы енгізіңіз',
        nameEn: 'Enter description',
    },
    'Введите высоту полёта': {
        nameRu: 'Введите высоту полёта',
        nameKz: 'Ұшу биіктігін енгізіңіз',
        nameEn: 'Enter flight altitude',
    },
    'Высота должна быть больше 0': {
        nameRu: 'Высота должна быть больше 0',
        nameKz: 'Биіктік 0-ден үлкен болуы керек',
        nameEn: 'Altitude must be greater than 0',
    },
    'Выберите дрон': {
        nameRu: 'Выберите дрон',
        nameKz: 'Дронды таңдаңыз',
        nameEn: 'Select a drone',
    },
    'Дата начала не может быть позже даты окончания': {
        nameRu: 'Дата начала не может быть позже даты окончания',
        nameKz: 'Басталу күні аяқталу күнінен кейін болмауы керек',
        nameEn: 'Start date cannot be later than end date',
    },
    'Время начала не может быть позже времени окончания': {
        nameRu: 'Время начала не может быть позже времени окончания',
        nameKz: 'Басталу уақыты аяқталу уақытынан кейін болмауы керек',
        nameEn: 'Start time cannot be later than end time',
    },
    'Нельзя выбрать прошедшую дату': {
        nameRu: 'Нельзя выбрать прошедшую дату',
        nameKz: 'Өткен күнді таңдауға болмайды',
        nameEn: 'Past date cannot be selected',
    },
    'Не удалось загрузить справочник назначений': {
        nameRu: 'Не удалось загрузить справочник назначений',
        nameKz: 'Мақсаттар анықтамалығын жүктеу мүмкін болмады',
        nameEn: 'Failed to load flight purposes dictionary',
    },
    'Сектор выбран': {
        nameRu: 'Сектор выбран',
        nameKz: 'Сектор таңдалды',
        nameEn: 'Sector selected',
    },
    'Секторы не найдены': {
        nameRu: 'Секторы не найдены',
        nameKz: 'Секторлар табылмады',
        nameEn: 'Sectors not found',
    },
    'Аватар успешно загружен': {
        nameRu: 'Аватар успешно загружен',
        nameKz: 'Аватар сәтті жүктелді',
        nameEn: 'Avatar uploaded successfully',
    },
    'Профиль успешно обновлен': {
        nameRu: 'Профиль успешно обновлен',
        nameKz: 'Профиль сәтті жаңартылды',
        nameEn: 'Profile updated successfully',
    },
    'Ошибка обновления профиля': {
        nameRu: 'Ошибка обновления профиля',
        nameKz: 'Профильді жаңарту қатесі',
        nameEn: 'Profile update error',
    },
    'Вход выполнен успешно': {
        nameRu: 'Вход выполнен успешно',
        nameKz: 'Кіру сәтті орындалды',
        nameEn: 'Signed in successfully',
    },
    'Регистрация выполнена успешно': {
        nameRu: 'Регистрация выполнена успешно',
        nameKz: 'Тіркелу сәтті орындалды',
        nameEn: 'Registration completed successfully',
    },
    'Выход выполнен успешно': {
        nameRu: 'Выход выполнен успешно',
        nameKz: 'Шығу сәтті орындалды',
        nameEn: 'Signed out successfully',
    },
    'Сеанс истек. Пожалуйста, войдите снова': {
        nameRu: 'Сеанс истек. Пожалуйста, войдите снова',
        nameKz: 'Сеанс аяқталды. Қайта кіріңіз',
        nameEn: 'Session expired. Please sign in again',
    },
    'Необходима авторизация': {
        nameRu: 'Необходима авторизация',
        nameKz: 'Авторизация қажет',
        nameEn: 'Authorization required',
    },
    'Поле обязательно для заполнения': {
        nameRu: 'Поле обязательно для заполнения',
        nameKz: 'Өріс міндетті түрде толтырылуы керек',
        nameEn: 'This field is required',
    },
    'Введите корректный номер телефона': {
        nameRu: 'Введите корректный номер телефона',
        nameKz: 'Дұрыс телефон нөмірін енгізіңіз',
        nameEn: 'Enter a valid phone number',
    },
    'Не удалось загрузить секторы': {
        nameRu: 'Не удалось загрузить секторы',
        nameKz: 'Секторларды жүктеу мүмкін болмады',
        nameEn: 'Failed to load sectors',
    },
    'Секторы пока не опубликованы': {
        nameRu: 'Секторы пока не опубликованы',
        nameKz: 'Секторлар әлі жарияланбаған',
        nameEn: 'Sectors are not published yet',
    },
    'Загрузка карты…': {
        nameRu: 'Загрузка карты…',
        nameKz: 'Карта жүктелуде…',
        nameEn: 'Loading map…',
    },
    'Обзор полётных зон': {
        nameRu: 'Обзор полётных зон',
        nameKz: 'Ұшу аймақтарына шолу',
        nameEn: 'Flight zones overview',
    },
    'Короткое видео о зонах — интерактивную карту откройте по кнопке ниже': {
        nameRu: 'Короткое видео о зонах — интерактивную карту откройте по кнопке ниже',
        nameKz: 'Аймақтар туралы қысқа бейне — интерактивті картаны төмендегі батырма арқылы ашыңыз',
        nameEn: 'A short video about zones — open the interactive map using the button below',
    },
    'Заявка на полёт не найдена': {
        nameRu: 'Заявка на полёт не найдена',
        nameKz: 'Ұшу өтініші табылмады',
        nameEn: 'Flight application not found',
    },
    'Не указана организация': {
        nameRu: 'Не указана организация',
        nameKz: 'Ұйым көрсетілмеген',
        nameEn: 'Organization not specified',
    },
    'Ошибка обновления': {
        nameRu: 'Ошибка обновления',
        nameKz: 'Жаңарту қатесі',
        nameEn: 'Update error',
    },
    'Ошибка обновления заявки': {
        nameRu: 'Ошибка обновления заявки',
        nameKz: 'Өтінішті жаңарту қатесі',
        nameEn: 'Application update error',
    },
    'Ошибка при применении изменений': {
        nameRu: 'Ошибка при применении изменений',
        nameKz: 'Өзгерістерді қолдану қатесі',
        nameEn: 'Error applying changes',
    },
    'Ошибка смены роли': {
        nameRu: 'Ошибка смены роли',
        nameKz: 'Рөлді өзгерту қатесі',
        nameEn: 'Role change error',
    },
    'Ошибка сохранения': {
        nameRu: 'Ошибка сохранения',
        nameKz: 'Сақтау қатесі',
        nameEn: 'Save error',
    },
    'Ошибка удаления': {
        nameRu: 'Ошибка удаления',
        nameKz: 'Жою қатесі',
        nameEn: 'Delete error',
    },
    'Изображение': {
        nameRu: 'Изображение',
        nameKz: 'Сурет',
        nameEn: 'Image',
    },
    'Содержание': {
        nameRu: 'Содержание',
        nameKz: 'Мазмұны',
        nameEn: 'Content',
    },
    'Root': {
        nameRu: 'Root',
        nameKz: 'Root',
        nameEn: 'Root',
    },
    'Планируемая дата и время ': {
        nameRu: 'Планируемая дата и время ',
        nameKz: 'Жоспарланған күні мен уақыты ',
        nameEn: 'Planned date and time ',
    },
    'Вы уверены, что хотите вернуть эту заявку на проверку? Статус заявки будет изменен на ': {
        nameRu: 'Вы уверены, что хотите вернуть эту заявку на проверку? Статус заявки будет изменен на ',
        nameKz: 'Бұл өтінішті тексеруге қайтарғыңыз келетініне сенімдісіз бе? Өтініш мәртебесі өзгертіледі: ',
        nameEn: 'Are you sure you want to return this application for review? The status will be changed to ',
    },
    'Для редактирования секторов перейдите в раздел ': {
        nameRu: 'Для редактирования секторов перейдите в раздел ',
        nameKz: 'Секторларды өңдеу үшін бөлімге өтіңіз ',
        nameEn: 'To edit sectors, go to the section ',
    },

}